var La = typeof global == "object" && global && global.Object === Object && global, on = typeof self == "object" && self && self.Object === Object && self, se = La || on || Function("return this")(), Le = se.Symbol, Oa = Object.prototype, sn = Oa.hasOwnProperty, ln = Oa.toString, ge = Le ? Le.toStringTag : void 0;
function cn(e) {
  var a = sn.call(e, ge), n = e[ge];
  try {
    e[ge] = void 0;
    var i = !0;
  } catch {
  }
  var r = ln.call(e);
  return i && (a ? e[ge] = n : delete e[ge]), r;
}
var un = Object.prototype, dn = un.toString;
function gn(e) {
  return dn.call(e);
}
var mn = "[object Null]", hn = "[object Undefined]", ia = Le ? Le.toStringTag : void 0;
function Ge(e) {
  return e == null ? e === void 0 ? hn : mn : ia && ia in Object(e) ? cn(e) : gn(e);
}
function pe(e) {
  return e != null && typeof e == "object";
}
var xe = Array.isArray;
function te(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function Ga(e) {
  return e;
}
var pn = "[object AsyncFunction]", fn = "[object Function]", yn = "[object GeneratorFunction]", bn = "[object Proxy]";
function je(e) {
  if (!te(e))
    return !1;
  var a = Ge(e);
  return a == fn || a == yn || a == pn || a == bn;
}
var ke = se["__core-js_shared__"], ta = function() {
  var e = /[^.]+$/.exec(ke && ke.keys && ke.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Dn(e) {
  return !!ta && ta in e;
}
var Cn = Function.prototype, Sn = Cn.toString;
function An(e) {
  if (e != null) {
    try {
      return Sn.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var wn = /[\\^$.*+?()[\]{}|]/g, vn = /^\[object .+?Constructor\]$/, Rn = Function.prototype, Mn = Object.prototype, Pn = Rn.toString, Tn = Mn.hasOwnProperty, Nn = RegExp(
  "^" + Pn.call(Tn).replace(wn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function En(e) {
  if (!te(e) || Dn(e))
    return !1;
  var a = je(e) ? Nn : vn;
  return a.test(An(e));
}
function Bn(e, a) {
  return e?.[a];
}
function Je(e, a) {
  var n = Bn(e, a);
  return En(n) ? n : void 0;
}
var ra = Object.create, zn = /* @__PURE__ */ function() {
  function e() {
  }
  return function(a) {
    if (!te(a))
      return {};
    if (ra)
      return ra(a);
    e.prototype = a;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Ln(e, a, n) {
  switch (n.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, n[0]);
    case 2:
      return e.call(a, n[0], n[1]);
    case 3:
      return e.call(a, n[0], n[1], n[2]);
  }
  return e.apply(a, n);
}
function On(e, a) {
  var n = -1, i = e.length;
  for (a || (a = Array(i)); ++n < i; )
    a[n] = e[n];
  return a;
}
var Gn = 800, In = 16, Kn = Date.now;
function _n(e) {
  var a = 0, n = 0;
  return function() {
    var i = Kn(), r = In - (i - n);
    if (n = i, r > 0) {
      if (++a >= Gn)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function Un(e) {
  return function() {
    return e;
  };
}
var Oe = function() {
  try {
    var e = Je(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Fn = Oe ? function(e, a) {
  return Oe(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Un(a),
    writable: !0
  });
} : Ga, kn = _n(Fn), Hn = 9007199254740991, $n = /^(?:0|[1-9]\d*)$/;
function Ia(e, a) {
  var n = typeof e;
  return a = a ?? Hn, !!a && (n == "number" || n != "symbol" && $n.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function qe(e, a, n) {
  a == "__proto__" && Oe ? Oe(e, a, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[a] = n;
}
function Ie(e, a) {
  return e === a || e !== e && a !== a;
}
var xn = Object.prototype, Yn = xn.hasOwnProperty;
function Vn(e, a, n) {
  var i = e[a];
  (!(Yn.call(e, a) && Ie(i, n)) || n === void 0 && !(a in e)) && qe(e, a, n);
}
function Zn(e, a, n, i) {
  var r = !n;
  n || (n = {});
  for (var l = -1, s = a.length; ++l < s; ) {
    var u = a[l], d = void 0;
    d === void 0 && (d = e[u]), r ? qe(n, u, d) : Vn(n, u, d);
  }
  return n;
}
var oa = Math.max;
function Wn(e, a, n) {
  return a = oa(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var i = arguments, r = -1, l = oa(i.length - a, 0), s = Array(l); ++r < l; )
      s[r] = i[a + r];
    r = -1;
    for (var u = Array(a + 1); ++r < a; )
      u[r] = i[r];
    return u[a] = n(s), Ln(e, this, u);
  };
}
function jn(e, a) {
  return kn(Wn(e, a, Ga), e + "");
}
var Jn = 9007199254740991;
function Ka(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Jn;
}
function Xe(e) {
  return e != null && Ka(e.length) && !je(e);
}
function qn(e, a, n) {
  if (!te(n))
    return !1;
  var i = typeof a;
  return (i == "number" ? Xe(n) && Ia(a, n.length) : i == "string" && a in n) ? Ie(n[a], e) : !1;
}
function Xn(e) {
  return jn(function(a, n) {
    var i = -1, r = n.length, l = r > 1 ? n[r - 1] : void 0, s = r > 2 ? n[2] : void 0;
    for (l = e.length > 3 && typeof l == "function" ? (r--, l) : void 0, s && qn(n[0], n[1], s) && (l = r < 3 ? void 0 : l, r = 1), a = Object(a); ++i < r; ) {
      var u = n[i];
      u && e(a, u, i, l);
    }
    return a;
  });
}
var Qn = Object.prototype;
function _a(e) {
  var a = e && e.constructor, n = typeof a == "function" && a.prototype || Qn;
  return e === n;
}
function ei(e, a) {
  for (var n = -1, i = Array(e); ++n < e; )
    i[n] = a(n);
  return i;
}
var ai = "[object Arguments]";
function sa(e) {
  return pe(e) && Ge(e) == ai;
}
var Ua = Object.prototype, ni = Ua.hasOwnProperty, ii = Ua.propertyIsEnumerable, Ye = sa(/* @__PURE__ */ function() {
  return arguments;
}()) ? sa : function(e) {
  return pe(e) && ni.call(e, "callee") && !ii.call(e, "callee");
};
function ti() {
  return !1;
}
var Fa = typeof exports == "object" && exports && !exports.nodeType && exports, la = Fa && typeof module == "object" && module && !module.nodeType && module, ri = la && la.exports === Fa, ca = ri ? se.Buffer : void 0, oi = ca ? ca.isBuffer : void 0, ka = oi || ti, si = "[object Arguments]", li = "[object Array]", ci = "[object Boolean]", ui = "[object Date]", di = "[object Error]", gi = "[object Function]", mi = "[object Map]", hi = "[object Number]", pi = "[object Object]", fi = "[object RegExp]", yi = "[object Set]", bi = "[object String]", Di = "[object WeakMap]", Ci = "[object ArrayBuffer]", Si = "[object DataView]", Ai = "[object Float32Array]", wi = "[object Float64Array]", vi = "[object Int8Array]", Ri = "[object Int16Array]", Mi = "[object Int32Array]", Pi = "[object Uint8Array]", Ti = "[object Uint8ClampedArray]", Ni = "[object Uint16Array]", Ei = "[object Uint32Array]", K = {};
K[Ai] = K[wi] = K[vi] = K[Ri] = K[Mi] = K[Pi] = K[Ti] = K[Ni] = K[Ei] = !0;
K[si] = K[li] = K[Ci] = K[ci] = K[Si] = K[ui] = K[di] = K[gi] = K[mi] = K[hi] = K[pi] = K[fi] = K[yi] = K[bi] = K[Di] = !1;
function Bi(e) {
  return pe(e) && Ka(e.length) && !!K[Ge(e)];
}
function zi(e) {
  return function(a) {
    return e(a);
  };
}
var Ha = typeof exports == "object" && exports && !exports.nodeType && exports, me = Ha && typeof module == "object" && module && !module.nodeType && module, Li = me && me.exports === Ha, He = Li && La.process, ua = function() {
  try {
    var e = me && me.require && me.require("util").types;
    return e || He && He.binding && He.binding("util");
  } catch {
  }
}(), da = ua && ua.isTypedArray, $a = da ? zi(da) : Bi;
function Oi(e, a) {
  var n = xe(e), i = !n && Ye(e), r = !n && !i && ka(e), l = !n && !i && !r && $a(e), s = n || i || r || l, u = s ? ei(e.length, String) : [], d = u.length;
  for (var f in e)
    s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    Ia(f, d)) || u.push(f);
  return u;
}
function Gi(e, a) {
  return function(n) {
    return e(a(n));
  };
}
function Ii(e) {
  var a = [];
  if (e != null)
    for (var n in Object(e))
      a.push(n);
  return a;
}
var Ki = Object.prototype, _i = Ki.hasOwnProperty;
function Ui(e) {
  if (!te(e))
    return Ii(e);
  var a = _a(e), n = [];
  for (var i in e)
    i == "constructor" && (a || !_i.call(e, i)) || n.push(i);
  return n;
}
function xa(e) {
  return Xe(e) ? Oi(e) : Ui(e);
}
var he = Je(Object, "create");
function Fi() {
  this.__data__ = he ? he(null) : {}, this.size = 0;
}
function ki(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var Hi = "__lodash_hash_undefined__", $i = Object.prototype, xi = $i.hasOwnProperty;
function Yi(e) {
  var a = this.__data__;
  if (he) {
    var n = a[e];
    return n === Hi ? void 0 : n;
  }
  return xi.call(a, e) ? a[e] : void 0;
}
var Vi = Object.prototype, Zi = Vi.hasOwnProperty;
function Wi(e) {
  var a = this.__data__;
  return he ? a[e] !== void 0 : Zi.call(a, e);
}
var ji = "__lodash_hash_undefined__";
function Ji(e, a) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = he && a === void 0 ? ji : a, this;
}
function ie(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var i = e[a];
    this.set(i[0], i[1]);
  }
}
ie.prototype.clear = Fi;
ie.prototype.delete = ki;
ie.prototype.get = Yi;
ie.prototype.has = Wi;
ie.prototype.set = Ji;
function qi() {
  this.__data__ = [], this.size = 0;
}
function Ke(e, a) {
  for (var n = e.length; n--; )
    if (Ie(e[n][0], a))
      return n;
  return -1;
}
var Xi = Array.prototype, Qi = Xi.splice;
function et(e) {
  var a = this.__data__, n = Ke(a, e);
  if (n < 0)
    return !1;
  var i = a.length - 1;
  return n == i ? a.pop() : Qi.call(a, n, 1), --this.size, !0;
}
function at(e) {
  var a = this.__data__, n = Ke(a, e);
  return n < 0 ? void 0 : a[n][1];
}
function nt(e) {
  return Ke(this.__data__, e) > -1;
}
function it(e, a) {
  var n = this.__data__, i = Ke(n, e);
  return i < 0 ? (++this.size, n.push([e, a])) : n[i][1] = a, this;
}
function q(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var i = e[a];
    this.set(i[0], i[1]);
  }
}
q.prototype.clear = qi;
q.prototype.delete = et;
q.prototype.get = at;
q.prototype.has = nt;
q.prototype.set = it;
var Ya = Je(se, "Map");
function tt() {
  this.size = 0, this.__data__ = {
    hash: new ie(),
    map: new (Ya || q)(),
    string: new ie()
  };
}
function rt(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function _e(e, a) {
  var n = e.__data__;
  return rt(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
}
function ot(e) {
  var a = _e(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function st(e) {
  return _e(this, e).get(e);
}
function lt(e) {
  return _e(this, e).has(e);
}
function ct(e, a) {
  var n = _e(this, e), i = n.size;
  return n.set(e, a), this.size += n.size == i ? 0 : 1, this;
}
function le(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var i = e[a];
    this.set(i[0], i[1]);
  }
}
le.prototype.clear = tt;
le.prototype.delete = ot;
le.prototype.get = st;
le.prototype.has = lt;
le.prototype.set = ct;
var Va = Gi(Object.getPrototypeOf, Object), ut = "[object Object]", dt = Function.prototype, gt = Object.prototype, Za = dt.toString, mt = gt.hasOwnProperty, ht = Za.call(Object);
function pt(e) {
  if (!pe(e) || Ge(e) != ut)
    return !1;
  var a = Va(e);
  if (a === null)
    return !0;
  var n = mt.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && Za.call(n) == ht;
}
function ft() {
  this.__data__ = new q(), this.size = 0;
}
function yt(e) {
  var a = this.__data__, n = a.delete(e);
  return this.size = a.size, n;
}
function bt(e) {
  return this.__data__.get(e);
}
function Dt(e) {
  return this.__data__.has(e);
}
var Ct = 200;
function St(e, a) {
  var n = this.__data__;
  if (n instanceof q) {
    var i = n.__data__;
    if (!Ya || i.length < Ct - 1)
      return i.push([e, a]), this.size = ++n.size, this;
    n = this.__data__ = new le(i);
  }
  return n.set(e, a), this.size = n.size, this;
}
function ce(e) {
  var a = this.__data__ = new q(e);
  this.size = a.size;
}
ce.prototype.clear = ft;
ce.prototype.delete = yt;
ce.prototype.get = bt;
ce.prototype.has = Dt;
ce.prototype.set = St;
var Wa = typeof exports == "object" && exports && !exports.nodeType && exports, ga = Wa && typeof module == "object" && module && !module.nodeType && module, At = ga && ga.exports === Wa, ma = At ? se.Buffer : void 0;
ma && ma.allocUnsafe;
function wt(e, a) {
  return e.slice();
}
var ha = se.Uint8Array;
function vt(e) {
  var a = new e.constructor(e.byteLength);
  return new ha(a).set(new ha(e)), a;
}
function Rt(e, a) {
  var n = vt(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
function Mt(e) {
  return typeof e.constructor == "function" && !_a(e) ? zn(Va(e)) : {};
}
function Pt(e) {
  return function(a, n, i) {
    for (var r = -1, l = Object(a), s = i(a), u = s.length; u--; ) {
      var d = s[++r];
      if (n(l[d], d, l) === !1)
        break;
    }
    return a;
  };
}
var Tt = Pt();
function Ve(e, a, n) {
  (n !== void 0 && !Ie(e[a], n) || n === void 0 && !(a in e)) && qe(e, a, n);
}
function Nt(e) {
  return pe(e) && Xe(e);
}
function Ze(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function Et(e) {
  return Zn(e, xa(e));
}
function Bt(e, a, n, i, r, l, s) {
  var u = Ze(e, n), d = Ze(a, n), f = s.get(d);
  if (f) {
    Ve(e, n, f);
    return;
  }
  var D = l ? l(u, d, n + "", e, a, s) : void 0, R = D === void 0;
  if (R) {
    var S = xe(d), w = !S && ka(d), v = !S && !w && $a(d);
    D = d, S || w || v ? xe(u) ? D = u : Nt(u) ? D = On(u) : w ? (R = !1, D = wt(d)) : v ? (R = !1, D = Rt(d)) : D = [] : pt(d) || Ye(d) ? (D = u, Ye(u) ? D = Et(u) : (!te(u) || je(u)) && (D = Mt(d))) : R = !1;
  }
  R && (s.set(d, D), r(D, d, i, l, s), s.delete(d)), Ve(e, n, D);
}
function ja(e, a, n, i, r) {
  e !== a && Tt(a, function(l, s) {
    if (r || (r = new ce()), te(l))
      Bt(e, a, s, n, ja, i, r);
    else {
      var u = i ? i(Ze(e, s), l, s + "", e, a, r) : void 0;
      u === void 0 && (u = l), Ve(e, s, u);
    }
  }, xa);
}
var pa = Xn(function(e, a, n) {
  ja(e, a, n);
});
const zt = "http://localhost".replace(/\/+$/, ""), Lt = (e) => typeof Blob < "u" && e instanceof Blob;
class J {
  constructor(a = new Ja()) {
    this.configuration = a, this.middleware = a.middleware;
  }
  middleware;
  withMiddleware(...a) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...a), n;
  }
  withPreMiddleware(...a) {
    const n = a.map((i) => ({ pre: i }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...a) {
    const n = a.map((i) => ({ post: i }));
    return this.withMiddleware(...n);
  }
  async request(a, n) {
    const { url: i, init: r } = this.createFetchParams(a, n), l = await this.fetchApi(i, r);
    if (l.status >= 200 && l.status < 300)
      return l;
    throw new Ot(l, "Response returned an error code");
  }
  createFetchParams(a, n) {
    let i = this.configuration.basePath + a.path;
    a.query !== void 0 && Object.keys(a.query).length !== 0 && (i += "?" + this.configuration.queryParamsStringify(a.query));
    const r = typeof FormData < "u" && a.body instanceof FormData || a.body instanceof URLSearchParams || Lt(a.body) ? a.body : JSON.stringify(a.body), l = Object.assign({}, this.configuration.headers, a.headers);
    Object.keys(l).forEach((u) => l[u] === void 0 ? delete l[u] : {});
    const s = {
      method: a.method,
      body: r,
      credentials: this.configuration.credentials,
      ...pa(n, {
        headers: pa({}, l, n?.headers)
      })
    };
    return { url: i, init: s };
  }
  fetchApi = async (a, n) => {
    let i = { url: a, init: n };
    for (const l of this.middleware)
      l.pre && (i = await l.pre({
        fetch: this.fetchApi,
        ...i
      }) || i);
    let r = await (this.configuration.fetchApi || fetch)(i.url, i.init);
    for (const l of this.middleware)
      l.post && (r = await l.post({
        fetch: this.fetchApi,
        url: i.url,
        init: i.init,
        response: r.clone()
      }) || r);
    return r;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const a = this.constructor, n = new a(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
}
class Ot extends Error {
  constructor(a, n) {
    super(n), this.response = a;
  }
  name = "ResponseError";
}
class U extends Error {
  constructor(a, n) {
    super(n), this.field = a;
  }
  name = "RequiredError";
}
const fo = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
class Ja {
  constructor(a = {}) {
    this.configuration = a;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : zt;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || qa;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const a = this.configuration.apiKey;
    if (a)
      return typeof a == "function" ? a : () => a;
  }
  get accessToken() {
    const a = this.configuration.accessToken;
    if (a)
      return typeof a == "function" ? a : async () => a;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
function yo(e, a) {
  const n = e[a];
  return n != null;
}
function qa(e, a = "") {
  return Object.keys(e).map((n) => {
    const i = a + (a.length ? `[${n}]` : n), r = e[n];
    if (r instanceof Array) {
      const l = r.map((s) => encodeURIComponent(String(s))).join(`&${encodeURIComponent(i)}=`);
      return `${encodeURIComponent(i)}=${l}`;
    }
    return r instanceof Date ? `${encodeURIComponent(i)}=${encodeURIComponent(r.toISOString())}` : r instanceof Object ? qa(r, i) : `${encodeURIComponent(i)}=${encodeURIComponent(String(r))}`;
  }).filter((n) => n.length > 0).join("&");
}
function bo(e, a) {
  return Object.keys(e).reduce(
    (n, i) => ({ ...n, [i]: a(e[i]) }),
    {}
  );
}
function Do(e) {
  for (const a of e)
    if (a.contentType === "multipart/form-data")
      return !0;
  return !1;
}
class _ {
  constructor(a, n = (i) => i) {
    this.raw = a, this.transformer = n;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class Co {
  constructor(a) {
    this.raw = a;
  }
  async value() {
  }
}
class So {
  constructor(a) {
    this.raw = a;
  }
  async value() {
    return await this.raw.blob();
  }
}
class Gt {
  constructor(a) {
    this.raw = a;
  }
  async value() {
    return await this.raw.text();
  }
}
const Ao = {
  Disabled: "DISABLED",
  Enabled: "ENABLED",
  Forced: "FORCED"
}, wo = {
  Cx: "bkg-cx",
  Cf: "bkg-cf",
  Created: "bkg-created",
  Af: "bkg-af",
  Ip: "bkg-ip",
  Pc: "bkg-pc",
  Pp: "bkg-pp",
  Qr: "bkg-qr"
}, vo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, Ro = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, Mo = {
  Dr: "dr",
  Mr: "mr",
  Mrs: "mrs",
  Ms: "ms",
  NotSpecified: "notSpecified",
  Prof: "prof"
}, Po = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, To = {
  Aed: "AED",
  Afn: "AFN",
  All: "ALL",
  Amd: "AMD",
  Ang: "ANG",
  Aoa: "AOA",
  Ars: "ARS",
  Aud: "AUD",
  Awg: "AWG",
  Azn: "AZN",
  Bam: "BAM",
  Bbd: "BBD",
  Bdt: "BDT",
  Bhd: "BHD",
  Bgn: "BGN",
  Bif: "BIF",
  Bmd: "BMD",
  Bnd: "BND",
  Bob: "BOB",
  Brl: "BRL",
  Bsd: "BSD",
  Bwp: "BWP",
  Bzd: "BZD",
  Cad: "CAD",
  Cdf: "CDF",
  Chf: "CHF",
  Clp: "CLP",
  Cny: "CNY",
  Cop: "COP",
  Crc: "CRC",
  Cve: "CVE",
  Czk: "CZK",
  Djf: "DJF",
  Dkk: "DKK",
  Dop: "DOP",
  Dzd: "DZD",
  Egp: "EGP",
  Etb: "ETB",
  Eur: "EUR",
  Fjd: "FJD",
  Fkp: "FKP",
  Gbp: "GBP",
  Gel: "GEL",
  Gip: "GIP",
  Gmd: "GMD",
  Gnf: "GNF",
  Gtq: "GTQ",
  Gyd: "GYD",
  Hkd: "HKD",
  Hnl: "HNL",
  Htg: "HTG",
  Huf: "HUF",
  Idr: "IDR",
  Ils: "ILS",
  Inr: "INR",
  Isk: "ISK",
  Jmd: "JMD",
  Jod: "JOD",
  Jpy: "JPY",
  Kes: "KES",
  Kgs: "KGS",
  Khr: "KHR",
  Kmf: "KMF",
  Krw: "KRW",
  Kwd: "KWD",
  Kyd: "KYD",
  Kzt: "KZT",
  Lak: "LAK",
  Lbp: "LBP",
  Lkr: "LKR",
  Lrd: "LRD",
  Lsl: "LSL",
  Mad: "MAD",
  Mdl: "MDL",
  Mga: "MGA",
  Mkd: "MKD",
  Mmk: "MMK",
  Mnt: "MNT",
  Mop: "MOP",
  Mru: "MRU",
  Mur: "MUR",
  Mvr: "MVR",
  Mwk: "MWK",
  Mxn: "MXN",
  Myr: "MYR",
  Mzn: "MZN",
  Nad: "NAD",
  Ngn: "NGN",
  Nio: "NIO",
  Nok: "NOK",
  Npr: "NPR",
  Nzd: "NZD",
  Omr: "OMR",
  Pab: "PAB",
  Pen: "PEN",
  Pgk: "PGK",
  Php: "PHP",
  Pkr: "PKR",
  Pln: "PLN",
  Pyg: "PYG",
  Qar: "QAR",
  Ron: "RON",
  Rsd: "RSD",
  Rub: "RUB",
  Rwf: "RWF",
  Sar: "SAR",
  Sbd: "SBD",
  Scr: "SCR",
  Sek: "SEK",
  Sgd: "SGD",
  Shp: "SHP",
  Sll: "SLL",
  Sos: "SOS",
  Srd: "SRD",
  Std: "STD",
  Szl: "SZL",
  Thb: "THB",
  Tjs: "TJS",
  Tnd: "TND",
  Top: "TOP",
  Try: "TRY",
  Ttd: "TTD",
  Twd: "TWD",
  Tzs: "TZS",
  Uah: "UAH",
  Usd: "USD",
  Uyu: "UYU",
  Uzs: "UZS",
  Vnd: "VND",
  Vuv: "VUV",
  Wst: "WST",
  Xaf: "XAF",
  Xcd: "XCD",
  Xof: "XOF",
  Xpf: "XPF",
  Yer: "YER",
  Zar: "ZAR",
  Zmw: "ZMW"
}, No = {
  ApiError: "api_error",
  BadGateway: "bad_gateway",
  InternalServerError: "internal_server_error",
  InvalidRequestError: "invalid_request_error",
  RateLimitError: "rate_limit_error",
  ResourceGone: "resource_gone",
  ResourceNotFound: "resource_not_found",
  Unauthorized: "unauthorized",
  ValidationError: "validation_error"
}, Eo = {
  Included: "INCLUDED",
  NotIncluded: "NOT_INCLUDED",
  Optional: "OPTIONAL"
}, Bo = {
  BestMatch: "BEST_MATCH",
  Cheapest: "CHEAPEST",
  MatchingRoomCount: "MATCHING_ROOM_COUNT",
  Regular: "REGULAR"
}, zo = {
  HotelRoom: "HOTEL_ROOM",
  Package: "PACKAGE"
}, Lo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, Oo = {
  CreditNote: "credit_note",
  Invoice: "invoice"
}, Go = {
  CreditCard: "CREDIT_CARD"
}, Io = {
  Coupon: "COUPON"
}, Ko = {
  DepositAccount: "DEPOSIT_ACCOUNT"
}, _o = {
  Coupon: "COUPON",
  CreditCard: "CREDIT_CARD",
  DepositAccount: "DEPOSIT_ACCOUNT"
}, Uo = {
  Complete: "COMPLETE",
  InProgress: "IN_PROGRESS"
}, Fo = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, ko = {
  Night: "PER_NIGHT",
  Stay: "PER_STAY"
}, Ho = {
  Adult: "PER_ADULT",
  Booking: "PER_BOOKING"
}, It = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), Kt = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), _t = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), Ut = /[^\p{L}\d]+/giu, fa = "$1\0$2", ya = "";
function Xa(e) {
  let a = e.trim();
  a = a.replace(It, fa).replace(Kt, fa), a = a.replace(Ut, "\0");
  let n = 0, i = a.length;
  for (; a.charAt(n) === "\0"; )
    n++;
  if (n === i)
    return [];
  for (; a.charAt(i - 1) === "\0"; )
    i--;
  return a.slice(n, i).split(/\0/g);
}
function Ft(e) {
  const a = Xa(e);
  for (let n = 0; n < a.length; n++) {
    const i = a[n], r = _t.exec(i);
    if (r) {
      const l = r.index + (r[1] ?? r[2]).length;
      a.splice(n, 1, i.slice(0, l), i.slice(l));
    }
  }
  return a;
}
function Qa(e, a) {
  const [n, i, r] = Fe(e, a);
  return n + i.map(Ue(a?.locale)).join(a?.delimiter ?? " ") + r;
}
function kt(e, a) {
  const [n, i, r] = Fe(e, a), l = Ue(a?.locale), s = Qe(a?.locale), u = a?.mergeAmbiguousCharacters ? ea(l, s) : an(l, s);
  return n + i.map((d, f) => f === 0 ? l(d) : u(d, f)).join(a?.delimiter ?? "") + r;
}
function Ht(e, a) {
  const [n, i, r] = Fe(e, a), l = Ue(a?.locale), s = Qe(a?.locale), u = a?.mergeAmbiguousCharacters ? ea(l, s) : an(l, s);
  return n + i.map(u).join(a?.delimiter ?? "") + r;
}
function $t(e, a) {
  const [n, i, r] = Fe(e, a), l = Ue(a?.locale), s = Qe(a?.locale);
  return n + i.map(ea(l, s)).join(a?.delimiter ?? " ") + r;
}
function en(e, a) {
  return Qa(e, { delimiter: "-", ...a });
}
function xt(e, a) {
  return Qa(e, { delimiter: "_", ...a });
}
function Ue(e) {
  return e === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e);
}
function Qe(e) {
  return e === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e);
}
function ea(e, a) {
  return (n) => `${a(n[0])}${e(n.slice(1))}`;
}
function an(e, a) {
  return (n, i) => {
    const r = n[0];
    return (i > 0 && r >= "0" && r <= "9" ? "_" + r : a(r)) + e(n.slice(1));
  };
}
function Fe(e, a = {}) {
  const n = a.split ?? (a.separateNumbers ? Ft : Xa), i = a.prefixCharacters ?? ya, r = a.suffixCharacters ?? ya;
  let l = 0, s = e.length;
  for (; l < e.length; ) {
    const u = e.charAt(l);
    if (!i.includes(u))
      break;
    l++;
  }
  for (; s > l; ) {
    const u = s - 1, d = e.charAt(u);
    if (!r.includes(d))
      break;
    s = u;
  }
  return [
    e.slice(0, l),
    n(e.slice(l, s)),
    e.slice(s)
  ];
}
var be = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function j(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ce = { exports: {} }, Yt = Ce.exports, ba;
function Vt() {
  return ba || (ba = 1, function(e, a) {
    (function(n, i, r) {
      e.exports = r(), e.exports.default = r();
    })("slugify", Yt, function() {
      var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), i = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function r(l, s) {
        if (typeof l != "string")
          throw new Error("slugify: string argument expected");
        s = typeof s == "string" ? { replacement: s } : s || {};
        var u = i[s.locale] || {}, d = s.replacement === void 0 ? "-" : s.replacement, f = s.trim === void 0 ? !0 : s.trim, D = l.normalize().split("").reduce(function(R, S) {
          var w = u[S];
          return w === void 0 && (w = n[S]), w === void 0 && (w = S), w === d && (w = " "), R + w.replace(s.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return s.strict && (D = D.replace(/[^A-Za-z0-9\s]/g, "")), f && (D = D.trim()), D = D.replace(/\s+/g, d), s.lower && (D = D.toLowerCase()), D;
      }
      return r.extend = function(l) {
        Object.assign(n, l);
      }, r;
    });
  }(Ce)), Ce.exports;
}
var Zt = Vt();
const Wt = /* @__PURE__ */ j(Zt);
function jt(e) {
  return Wt(en(e), {
    lower: !0,
    strict: !0
  });
}
var C = /* @__PURE__ */ ((e) => (e.Camel = "camelCase", e.Capital = "capitalCase", e.Param = "paramCase", e.Pascal = "pascalCase", e.Slug = "slugCase", e.Snake = "snakeCase", e))(C || {});
const Jt = {
  camelCase: kt,
  capitalCase: $t,
  paramCase: en,
  pascalCase: Ht,
  slugCase: jt,
  snakeCase: xt
};
function qt(e, a) {
  return e.some(
    (n) => typeof n == "string" ? n === a : n.test(a)
  );
}
function Xt(e) {
  return e === Object(e) && !Array.isArray(e) && typeof e != "function";
}
function b(e, a, n = { deep: !0 }) {
  return Xt(e) ? Object.keys(e).reduce((i, r) => {
    const l = n?.exclude && qt(n.exclude, r) ? r : Jt[a](r);
    return i[l] = n.deep ? b(e[r], a, n) : e[r], i;
  }, {}) : Array.isArray(e) ? e.map((i) => b(i, a, n)) : e;
}
function Qt(e, a) {
  const n = {};
  for (const i of a)
    Object.hasOwn(e, i) && (n[i] = e[i]);
  return n;
}
var t = /* @__PURE__ */ ((e) => (e.AED = "AED", e.AFN = "AFN", e.ALL = "ALL", e.AMD = "AMD", e.ANG = "ANG", e.AOA = "AOA", e.ARS = "ARS", e.AUD = "AUD", e.AWG = "AWG", e.AZN = "AZN", e.BAM = "BAM", e.BBD = "BBD", e.BDT = "BDT", e.BGN = "BGN", e.BHD = "BHD", e.BIF = "BIF", e.BMD = "BMD", e.BND = "BND", e.BOB = "BOB", e.BRL = "BRL", e.BSD = "BSD", e.BTN = "BTN", e.BWP = "BWP", e.BYN = "BYN", e.BYR = "BYR", e.BZD = "BZD", e.CAD = "CAD", e.CDF = "CDF", e.CHF = "CHF", e.CLF = "CLF", e.CLP = "CLP", e.CNY = "CNY", e.COP = "COP", e.CRC = "CRC", e.CUC = "CUC", e.CUP = "CUP", e.CVE = "CVE", e.CZK = "CZK", e.DJF = "DJF", e.DKK = "DKK", e.DOP = "DOP", e.DZD = "DZD", e.EEK = "EEK", e.EGP = "EGP", e.ERN = "ERN", e.ETB = "ETB", e.EUR = "EUR", e.FJD = "FJD", e.FKP = "FKP", e.GBP = "GBP", e.GEL = "GEL", e.GHS = "GHS", e.GIP = "GIP", e.GMD = "GMD", e.GNF = "GNF", e.GTQ = "GTQ", e.GYD = "GYD", e.HKD = "HKD", e.HNL = "HNL", e.HRK = "HRK", e.HTG = "HTG", e.HUF = "HUF", e.IDR = "IDR", e.ILS = "ILS", e.INR = "INR", e.IQD = "IQD", e.IRR = "IRR", e.ISK = "ISK", e.JMD = "JMD", e.JOD = "JOD", e.JPY = "JPY", e.KES = "KES", e.KGS = "KGS", e.KHR = "KHR", e.KMF = "KMF", e.KPW = "KPW", e.KRW = "KRW", e.KWD = "KWD", e.KYD = "KYD", e.KZT = "KZT", e.LAK = "LAK", e.LBP = "LBP", e.LKR = "LKR", e.LRD = "LRD", e.LSL = "LSL", e.LTL = "LTL", e.LVL = "LVL", e.LYD = "LYD", e.MAD = "MAD", e.MDL = "MDL", e.MGA = "MGA", e.MKD = "MKD", e.MMK = "MMK", e.MNT = "MNT", e.MOP = "MOP", e.MRO = "MRO", e.MRU = "MRU", e.MUR = "MUR", e.MVR = "MVR", e.MWK = "MWK", e.MXN = "MXN", e.MYR = "MYR", e.MZN = "MZN", e.NAD = "NAD", e.NGN = "NGN", e.NIO = "NIO", e.NOK = "NOK", e.NPR = "NPR", e.NZD = "NZD", e.OMR = "OMR", e.PAB = "PAB", e.PEN = "PEN", e.PGK = "PGK", e.PHP = "PHP", e.PKR = "PKR", e.PLN = "PLN", e.PYG = "PYG", e.QAR = "QAR", e.RON = "RON", e.RSD = "RSD", e.RUB = "RUB", e.RWF = "RWF", e.SAR = "SAR", e.SBD = "SBD", e.SCR = "SCR", e.SDG = "SDG", e.SEK = "SEK", e.SGD = "SGD", e.SHP = "SHP", e.SLL = "SLL", e.SOS = "SOS", e.SRD = "SRD", e.SSP = "SSP", e.STD = "STD", e.SYP = "SYP", e.SZL = "SZL", e.THB = "THB", e.TJS = "TJS", e.TMT = "TMT", e.TND = "TND", e.TOP = "TOP", e.TRY = "TRY", e.TTD = "TTD", e.TWD = "TWD", e.TZS = "TZS", e.UAH = "UAH", e.UGX = "UGX", e.USD = "USD", e.UYU = "UYU", e.UZS = "UZS", e.VEF = "VEF", e.VES = "VES", e.VND = "VND", e.VUV = "VUV", e.WST = "WST", e.XAF = "XAF", e.XCD = "XCD", e.XOF = "XOF", e.XPF = "XPF", e.YER = "YER", e.ZAR = "ZAR", e.ZMK = "ZMK", e.ZMW = "ZMW", e.ZWL = "ZWL", e))(t || {});
const aa = {
  AED: {
    code: "AED",
    decimalDigits: 2,
    name: "United Arab Emirates Dirham",
    namePlural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbolNative: "د.إ.‏",
    zeroDecimal: !1
  },
  AFN: {
    code: "AFN",
    decimalDigits: 0,
    name: "Afghan Afghani",
    namePlural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbolNative: "؋",
    zeroDecimal: !1
  },
  ALL: {
    code: "ALL",
    decimalDigits: 0,
    name: "Albanian Lek",
    namePlural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbolNative: "Lek",
    zeroDecimal: !1
  },
  AMD: {
    code: "AMD",
    decimalDigits: 0,
    name: "Armenian Dram",
    namePlural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbolNative: "դր.",
    zeroDecimal: !1
  },
  ANG: {
    code: "ANG",
    decimalDigits: 2,
    name: "Netherlands Antillean Guilder",
    namePlural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbolNative: "NAf.",
    zeroDecimal: !1
  },
  AOA: {
    code: "AOA",
    decimalDigits: 2,
    name: "Angolan Kwanza",
    namePlural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbolNative: "Kz",
    zeroDecimal: !1
  },
  ARS: {
    code: "ARS",
    decimalDigits: 2,
    name: "Argentine Peso",
    namePlural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AUD: {
    code: "AUD",
    decimalDigits: 2,
    name: "Australian Dollar",
    namePlural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AWG: {
    code: "AWG",
    decimalDigits: 2,
    name: "Aruban Florin",
    namePlural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbolNative: "Afl.",
    zeroDecimal: !1
  },
  AZN: {
    code: "AZN",
    decimalDigits: 2,
    name: "Azerbaijani Manat",
    namePlural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbolNative: "ман.",
    zeroDecimal: !1
  },
  BAM: {
    code: "BAM",
    decimalDigits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    namePlural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbolNative: "KM",
    zeroDecimal: !1
  },
  BBD: {
    code: "BBD",
    decimalDigits: 2,
    name: "Barbadian Dollar",
    namePlural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BDT: {
    code: "BDT",
    decimalDigits: 2,
    name: "Bangladeshi Taka",
    namePlural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbolNative: "৳",
    zeroDecimal: !1
  },
  BGN: {
    code: "BGN",
    decimalDigits: 2,
    name: "Bulgarian Lev",
    namePlural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbolNative: "лв.",
    zeroDecimal: !1
  },
  BHD: {
    code: "BHD",
    decimalDigits: 3,
    name: "Bahraini Dinar",
    namePlural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbolNative: "د.ب.‏",
    zeroDecimal: !1
  },
  BIF: {
    code: "BIF",
    decimalDigits: 0,
    name: "Burundian Franc",
    namePlural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbolNative: "FBu",
    zeroDecimal: !0
  },
  BMD: {
    code: "BMD",
    decimalDigits: 2,
    name: "Bermudan Dollar",
    namePlural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BND: {
    code: "BND",
    decimalDigits: 2,
    name: "Brunei Dollar",
    namePlural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BOB: {
    code: "BOB",
    decimalDigits: 2,
    name: "Bolivian Boliviano",
    namePlural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbolNative: "Bs",
    zeroDecimal: !1
  },
  BRL: {
    code: "BRL",
    decimalDigits: 2,
    name: "Brazilian Real",
    namePlural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbolNative: "R$",
    zeroDecimal: !1
  },
  BSD: {
    code: "BSD",
    decimalDigits: 2,
    name: "Bahamian Dollar",
    namePlural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BTN: {
    code: "BTN",
    decimalDigits: 2,
    name: "Bhutanese Ngultrum",
    namePlural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbolNative: "Nu.",
    zeroDecimal: !1
  },
  BWP: {
    code: "BWP",
    decimalDigits: 2,
    name: "Botswanan Pula",
    namePlural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbolNative: "P",
    zeroDecimal: !1
  },
  BYN: {
    code: "BYN",
    decimalDigits: 2,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbolNative: "руб.",
    zeroDecimal: !1
  },
  BYR: {
    code: "BYR",
    decimalDigits: 0,
    deprecated: !0,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "BYR",
    symbolNative: "BYR",
    zeroDecimal: !1
  },
  BZD: {
    code: "BZD",
    decimalDigits: 2,
    name: "Belize Dollar",
    namePlural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CAD: {
    code: "CAD",
    decimalDigits: 2,
    name: "Canadian Dollar",
    namePlural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CDF: {
    code: "CDF",
    decimalDigits: 2,
    name: "Congolese Franc",
    namePlural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbolNative: "FrCD",
    zeroDecimal: !1
  },
  CHF: {
    code: "CHF",
    decimalDigits: 2,
    name: "Swiss Franc",
    namePlural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbolNative: "CHF",
    zeroDecimal: !1
  },
  CLF: {
    code: "CLF",
    decimalDigits: 4,
    deprecated: !0,
    name: "Chilean Unit of Account (UF)",
    namePlural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbolNative: "CLF",
    zeroDecimal: !1
  },
  CLP: {
    code: "CLP",
    decimalDigits: 0,
    name: "Chilean Peso",
    namePlural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbolNative: "$",
    zeroDecimal: !0
  },
  CNY: {
    code: "CNY",
    decimalDigits: 2,
    name: "Chinese Yuan",
    namePlural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbolNative: "CN¥",
    zeroDecimal: !1
  },
  COP: {
    code: "COP",
    decimalDigits: 0,
    name: "Colombian Peso",
    namePlural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CRC: {
    code: "CRC",
    decimalDigits: 0,
    name: "Costa Rican Colón",
    namePlural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    zeroDecimal: !1
  },
  CUC: {
    code: "CUC",
    decimalDigits: 2,
    name: "Cuban Convertible Peso",
    namePlural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbolNative: "CUC",
    zeroDecimal: !1
  },
  CUP: {
    code: "CUP",
    decimalDigits: 2,
    name: "Cuban Peso",
    namePlural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CVE: {
    code: "CVE",
    decimalDigits: 2,
    name: "Cape Verdean Escudo",
    namePlural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbolNative: "CV$",
    zeroDecimal: !1
  },
  CZK: {
    code: "CZK",
    decimalDigits: 2,
    name: "Czech Republic Koruna",
    namePlural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbolNative: "Kč",
    zeroDecimal: !1
  },
  DJF: {
    code: "DJF",
    decimalDigits: 0,
    name: "Djiboutian Franc",
    namePlural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbolNative: "Fdj",
    zeroDecimal: !0
  },
  DKK: {
    code: "DKK",
    decimalDigits: 2,
    name: "Danish Krone",
    namePlural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  DOP: {
    code: "DOP",
    decimalDigits: 2,
    name: "Dominican Peso",
    namePlural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbolNative: "RD$",
    zeroDecimal: !1
  },
  DZD: {
    code: "DZD",
    decimalDigits: 2,
    name: "Algerian Dinar",
    namePlural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbolNative: "د.ج.‏",
    zeroDecimal: !1
  },
  EEK: {
    code: "EEK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Estonian Kroon",
    namePlural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  EGP: {
    code: "EGP",
    decimalDigits: 2,
    name: "Egyptian Pound",
    namePlural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    zeroDecimal: !1
  },
  ERN: {
    code: "ERN",
    decimalDigits: 2,
    name: "Eritrean Nakfa",
    namePlural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbolNative: "Nfk",
    zeroDecimal: !1
  },
  ETB: {
    code: "ETB",
    decimalDigits: 2,
    name: "Ethiopian Birr",
    namePlural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    zeroDecimal: !1
  },
  EUR: {
    code: "EUR",
    decimalDigits: 2,
    name: "Euro",
    namePlural: "euros",
    rounding: 0,
    symbol: "€",
    symbolNative: "€",
    zeroDecimal: !1
  },
  FJD: {
    code: "FJD",
    decimalDigits: 2,
    name: "Fijian Dollar",
    namePlural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  FKP: {
    code: "FKP",
    decimalDigits: 2,
    name: "Falkland Islands Pound",
    namePlural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GBP: {
    code: "GBP",
    decimalDigits: 2,
    name: "British Pound Sterling",
    namePlural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GEL: {
    code: "GEL",
    decimalDigits: 2,
    name: "Georgian Lari",
    namePlural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbolNative: "GEL",
    zeroDecimal: !1
  },
  GHS: {
    code: "GHS",
    decimalDigits: 2,
    name: "Ghanaian Cedi",
    namePlural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbolNative: "GH₵",
    zeroDecimal: !1
  },
  GIP: {
    code: "GIP",
    decimalDigits: 2,
    name: "Gibraltar Pound",
    namePlural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GMD: {
    code: "GMD",
    decimalDigits: 2,
    name: "Gambian Dalasi",
    namePlural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbolNative: "D",
    zeroDecimal: !1
  },
  GNF: {
    code: "GNF",
    decimalDigits: 0,
    name: "Guinean Franc",
    namePlural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbolNative: "FG",
    zeroDecimal: !0
  },
  GTQ: {
    code: "GTQ",
    decimalDigits: 2,
    name: "Guatemalan Quetzal",
    namePlural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbolNative: "Q",
    zeroDecimal: !1
  },
  GYD: {
    code: "GYD",
    decimalDigits: 0,
    name: "Guyanaese Dollar",
    namePlural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HKD: {
    code: "HKD",
    decimalDigits: 2,
    name: "Hong Kong Dollar",
    namePlural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HNL: {
    code: "HNL",
    decimalDigits: 2,
    name: "Honduran Lempira",
    namePlural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbolNative: "L",
    zeroDecimal: !1
  },
  HRK: {
    code: "HRK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Croatian Kuna",
    namePlural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbolNative: "kn",
    zeroDecimal: !1
  },
  HTG: {
    code: "HTG",
    decimalDigits: 2,
    name: "Haitian Gourde",
    namePlural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbolNative: "G",
    zeroDecimal: !1
  },
  HUF: {
    code: "HUF",
    decimalDigits: 0,
    name: "Hungarian Forint",
    namePlural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbolNative: "Ft",
    zeroDecimal: !1
  },
  IDR: {
    code: "IDR",
    decimalDigits: 0,
    name: "Indonesian Rupiah",
    namePlural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbolNative: "Rp",
    zeroDecimal: !1
  },
  ILS: {
    code: "ILS",
    decimalDigits: 2,
    name: "Israeli New Sheqel",
    namePlural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbolNative: "₪",
    zeroDecimal: !1
  },
  INR: {
    code: "INR",
    decimalDigits: 2,
    name: "Indian Rupee",
    namePlural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbolNative: "টকা",
    zeroDecimal: !1
  },
  IQD: {
    code: "IQD",
    decimalDigits: 0,
    name: "Iraqi Dinar",
    namePlural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    zeroDecimal: !1
  },
  IRR: {
    code: "IRR",
    decimalDigits: 0,
    name: "Iranian Rial",
    namePlural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbolNative: "﷼",
    zeroDecimal: !0
  },
  ISK: {
    code: "ISK",
    decimalDigits: 0,
    name: "Icelandic Króna",
    namePlural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  JMD: {
    code: "JMD",
    decimalDigits: 2,
    name: "Jamaican Dollar",
    namePlural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  JOD: {
    code: "JOD",
    decimalDigits: 3,
    name: "Jordanian Dinar",
    namePlural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbolNative: "د.أ.‏",
    zeroDecimal: !1
  },
  JPY: {
    code: "JPY",
    decimalDigits: 0,
    name: "Japanese Yen",
    namePlural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbolNative: "￥",
    zeroDecimal: !0
  },
  KES: {
    code: "KES",
    decimalDigits: 2,
    name: "Kenyan Shilling",
    namePlural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbolNative: "Ksh",
    zeroDecimal: !1
  },
  KGS: {
    code: "KGS",
    decimalDigits: 2,
    name: "Kyrgystani Som",
    namePlural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbolNative: "сом",
    zeroDecimal: !1
  },
  KHR: {
    code: "KHR",
    decimalDigits: 2,
    name: "Cambodian Riel",
    namePlural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbolNative: "៛",
    zeroDecimal: !1
  },
  KMF: {
    code: "KMF",
    decimalDigits: 0,
    name: "Comorian Franc",
    namePlural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbolNative: "FC",
    zeroDecimal: !0
  },
  KPW: {
    code: "KPW",
    decimalDigits: 0,
    name: "North Korean Won",
    namePlural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbolNative: "KPW",
    zeroDecimal: !1
  },
  KRW: {
    code: "KRW",
    decimalDigits: 0,
    name: "South Korean Won",
    namePlural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    zeroDecimal: !0
  },
  KWD: {
    code: "KWD",
    decimalDigits: 3,
    name: "Kuwaiti Dinar",
    namePlural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbolNative: "د.ك.‏",
    zeroDecimal: !1
  },
  KYD: {
    code: "KYD",
    decimalDigits: 2,
    name: "Cayman Islands Dollar",
    namePlural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  KZT: {
    code: "KZT",
    decimalDigits: 2,
    name: "Kazakhstani Tenge",
    namePlural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbolNative: "тңг.",
    zeroDecimal: !1
  },
  LAK: {
    code: "LAK",
    decimalDigits: 0,
    name: "Laotian Kip",
    namePlural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbolNative: "₭",
    zeroDecimal: !1
  },
  LBP: {
    code: "LBP",
    decimalDigits: 0,
    name: "Lebanese Pound",
    namePlural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    zeroDecimal: !1
  },
  LKR: {
    code: "LKR",
    decimalDigits: 2,
    name: "Sri Lankan Rupee",
    namePlural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbolNative: "SL Re",
    zeroDecimal: !1
  },
  LRD: {
    code: "LRD",
    decimalDigits: 2,
    name: "Liberian Dollar",
    namePlural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  LSL: {
    code: "LSL",
    decimalDigits: 2,
    name: "Lesotho Loti",
    namePlural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbolNative: "LSL",
    zeroDecimal: !1
  },
  LTL: {
    code: "LTL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Lithuanian Litas",
    namePlural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbolNative: "Lt",
    zeroDecimal: !1
  },
  LVL: {
    code: "LVL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Latvian Lats",
    namePlural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbolNative: "Ls",
    zeroDecimal: !1
  },
  LYD: {
    code: "LYD",
    decimalDigits: 3,
    name: "Libyan Dinar",
    namePlural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbolNative: "د.ل.‏",
    zeroDecimal: !1
  },
  MAD: {
    code: "MAD",
    decimalDigits: 2,
    name: "Moroccan Dirham",
    namePlural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbolNative: "د.م.‏",
    zeroDecimal: !1
  },
  MDL: {
    code: "MDL",
    decimalDigits: 2,
    name: "Moldovan Leu",
    namePlural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbolNative: "MDL",
    zeroDecimal: !1
  },
  MGA: {
    code: "MGA",
    decimalDigits: 0,
    name: "Malagasy Ariary",
    namePlural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbolNative: "MGA",
    zeroDecimal: !0
  },
  MKD: {
    code: "MKD",
    decimalDigits: 2,
    name: "Macedonian Denar",
    namePlural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbolNative: "MKD",
    zeroDecimal: !1
  },
  MMK: {
    code: "MMK",
    decimalDigits: 0,
    name: "Myanma Kyat",
    namePlural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  MNT: {
    code: "MNT",
    decimalDigits: 0,
    name: "Mongolian Tugrik",
    namePlural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbolNative: "₮",
    zeroDecimal: !1
  },
  MOP: {
    code: "MOP",
    decimalDigits: 2,
    name: "Macanese Pataca",
    namePlural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbolNative: "MOP$",
    zeroDecimal: !1
  },
  MRO: {
    code: "MRO",
    decimalDigits: 0,
    deprecated: !0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MRU: {
    code: "MRU",
    decimalDigits: 0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRU",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MUR: {
    code: "MUR",
    decimalDigits: 0,
    name: "Mauritian Rupee",
    namePlural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbolNative: "MURs",
    zeroDecimal: !1
  },
  MVR: {
    code: "MVR",
    decimalDigits: 0,
    name: "Maldivian rufiyaa",
    namePlural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbolNative: "Rf",
    zeroDecimal: !1
  },
  MWK: {
    code: "MWK",
    decimalDigits: 2,
    name: "Malawian Kwacha",
    namePlural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbolNative: "MK",
    zeroDecimal: !1
  },
  MXN: {
    code: "MXN",
    decimalDigits: 2,
    name: "Mexican Peso",
    namePlural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  MYR: {
    code: "MYR",
    decimalDigits: 2,
    name: "Malaysian Ringgit",
    namePlural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbolNative: "RM",
    zeroDecimal: !1
  },
  MZN: {
    code: "MZN",
    decimalDigits: 2,
    name: "Mozambican Metical",
    namePlural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbolNative: "MTn",
    zeroDecimal: !1
  },
  NAD: {
    code: "NAD",
    decimalDigits: 2,
    name: "Namibian Dollar",
    namePlural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbolNative: "N$",
    zeroDecimal: !1
  },
  NGN: {
    code: "NGN",
    decimalDigits: 2,
    name: "Nigerian Naira",
    namePlural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbolNative: "₦",
    zeroDecimal: !1
  },
  NIO: {
    code: "NIO",
    decimalDigits: 2,
    name: "Nicaraguan Córdoba",
    namePlural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbolNative: "C$",
    zeroDecimal: !1
  },
  NOK: {
    code: "NOK",
    decimalDigits: 2,
    name: "Norwegian Krone",
    namePlural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  NPR: {
    code: "NPR",
    decimalDigits: 2,
    name: "Nepalese Rupee",
    namePlural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbolNative: "नेरू",
    zeroDecimal: !1
  },
  NZD: {
    code: "NZD",
    decimalDigits: 2,
    name: "New Zealand Dollar",
    namePlural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  OMR: {
    code: "OMR",
    decimalDigits: 3,
    name: "Omani Rial",
    namePlural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    zeroDecimal: !1
  },
  PAB: {
    code: "PAB",
    decimalDigits: 2,
    name: "Panamanian Balboa",
    namePlural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbolNative: "B/.",
    zeroDecimal: !1
  },
  PEN: {
    code: "PEN",
    decimalDigits: 2,
    name: "Peruvian Nuevo Sol",
    namePlural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbolNative: "S/.",
    zeroDecimal: !1
  },
  PGK: {
    code: "PGK",
    decimalDigits: 2,
    name: "Papua New Guinean Kina",
    namePlural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  PHP: {
    code: "PHP",
    decimalDigits: 2,
    name: "Philippine Peso",
    namePlural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbolNative: "₱",
    zeroDecimal: !1
  },
  PKR: {
    code: "PKR",
    decimalDigits: 0,
    name: "Pakistani Rupee",
    namePlural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbolNative: "₨",
    zeroDecimal: !1
  },
  PLN: {
    code: "PLN",
    decimalDigits: 2,
    name: "Polish Zloty",
    namePlural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbolNative: "zł",
    zeroDecimal: !1
  },
  PYG: {
    code: "PYG",
    decimalDigits: 0,
    name: "Paraguayan Guarani",
    namePlural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbolNative: "₲",
    zeroDecimal: !0
  },
  QAR: {
    code: "QAR",
    decimalDigits: 2,
    name: "Qatari Rial",
    namePlural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    zeroDecimal: !1
  },
  RON: {
    code: "RON",
    decimalDigits: 2,
    name: "Romanian Leu",
    namePlural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbolNative: "RON",
    zeroDecimal: !1
  },
  RSD: {
    code: "RSD",
    decimalDigits: 0,
    name: "Serbian Dinar",
    namePlural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbolNative: "дин.",
    zeroDecimal: !1
  },
  RUB: {
    code: "RUB",
    decimalDigits: 2,
    name: "Russian Ruble",
    namePlural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbolNative: "₽.",
    zeroDecimal: !1
  },
  RWF: {
    code: "RWF",
    decimalDigits: 0,
    name: "Rwandan Franc",
    namePlural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbolNative: "FR",
    zeroDecimal: !0
  },
  SAR: {
    code: "SAR",
    decimalDigits: 2,
    name: "Saudi Riyal",
    namePlural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbolNative: "ر.س.‏",
    zeroDecimal: !1
  },
  SBD: {
    code: "SBD",
    decimalDigits: 2,
    name: "Solomon Islands Dollar",
    namePlural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SCR: {
    code: "SCR",
    decimalDigits: 2,
    name: "Seychellois Rupee",
    namePlural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbolNative: "SR",
    zeroDecimal: !1
  },
  SDG: {
    code: "SDG",
    decimalDigits: 2,
    name: "Sudanese Pound",
    namePlural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbolNative: "SDG",
    zeroDecimal: !1
  },
  SEK: {
    code: "SEK",
    decimalDigits: 2,
    name: "Swedish Krona",
    namePlural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  SGD: {
    code: "SGD",
    decimalDigits: 2,
    name: "Singapore Dollar",
    namePlural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SHP: {
    code: "SHP",
    decimalDigits: 2,
    name: "St. Helena Pound",
    namePlural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  SLL: {
    code: "SLL",
    decimalDigits: 0,
    name: "Sierra Leonean Leone",
    namePlural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbolNative: "Le",
    zeroDecimal: !1
  },
  SOS: {
    code: "SOS",
    decimalDigits: 0,
    name: "Somali Shilling",
    namePlural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbolNative: "Ssh",
    zeroDecimal: !1
  },
  SRD: {
    code: "SRD",
    decimalDigits: 2,
    name: "Surinamese Dollar",
    namePlural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SSP: {
    code: "SSP",
    decimalDigits: 2,
    deprecated: !0,
    name: "South Sudanese Pound",
    namePlural: "South Sudanese pounds",
    rounding: 0,
    symbol: "SSP",
    symbolNative: "SSP",
    zeroDecimal: !1
  },
  STD: {
    code: "STD",
    decimalDigits: 2,
    name: "Dobra",
    namePlural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbolNative: "Db",
    zeroDecimal: !1
  },
  SYP: {
    code: "SYP",
    decimalDigits: 0,
    name: "Syrian Pound",
    namePlural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    zeroDecimal: !1
  },
  SZL: {
    code: "SZL",
    decimalDigits: 2,
    name: "Swazi Lilangeni",
    namePlural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbolNative: "E",
    zeroDecimal: !1
  },
  THB: {
    code: "THB",
    decimalDigits: 2,
    name: "Thai Baht",
    namePlural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbolNative: "฿",
    zeroDecimal: !1
  },
  TJS: {
    code: "TJS",
    decimalDigits: 2,
    name: "Tajikistani Somoni",
    namePlural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbolNative: "сом.",
    zeroDecimal: !1
  },
  TMT: {
    code: "TMT",
    decimalDigits: 2,
    name: "Turkmenistan Manat",
    namePlural: "Turkmenistan manats",
    rounding: 0,
    symbol: "TMT",
    symbolNative: "TMT",
    zeroDecimal: !1
  },
  TND: {
    code: "TND",
    decimalDigits: 3,
    name: "Tunisian Dinar",
    namePlural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbolNative: "د.ت.‏",
    zeroDecimal: !1
  },
  TOP: {
    code: "TOP",
    decimalDigits: 2,
    name: "Tongan Paʻanga",
    namePlural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbolNative: "T$",
    zeroDecimal: !1
  },
  TRY: {
    code: "TRY",
    decimalDigits: 2,
    name: "Turkish Lira",
    namePlural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbolNative: "TL",
    zeroDecimal: !1
  },
  TTD: {
    code: "TTD",
    decimalDigits: 2,
    name: "Trinidad and Tobago Dollar",
    namePlural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  TWD: {
    code: "TWD",
    decimalDigits: 2,
    name: "New Taiwan Dollar",
    namePlural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbolNative: "NT$",
    zeroDecimal: !1
  },
  TZS: {
    code: "TZS",
    decimalDigits: 0,
    name: "Tanzanian Shilling",
    namePlural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbolNative: "TSh",
    zeroDecimal: !1
  },
  UAH: {
    code: "UAH",
    decimalDigits: 2,
    name: "Ukrainian Hryvnia",
    namePlural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbolNative: "₴",
    zeroDecimal: !1
  },
  UGX: {
    code: "UGX",
    decimalDigits: 0,
    name: "Ugandan Shilling",
    namePlural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbolNative: "USh",
    zeroDecimal: !0
  },
  USD: {
    code: "USD",
    decimalDigits: 2,
    name: "US Dollar",
    namePlural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UYU: {
    code: "UYU",
    decimalDigits: 2,
    name: "Uruguayan Peso",
    namePlural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UZS: {
    code: "UZS",
    decimalDigits: 0,
    name: "Uzbekistan Som",
    namePlural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbolNative: "UZS",
    zeroDecimal: !1
  },
  VEF: {
    code: "VEF",
    decimalDigits: 2,
    deprecated: !0,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VES: {
    code: "VES",
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VND: {
    code: "VND",
    decimalDigits: 0,
    name: "Vietnamese Dong",
    namePlural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbolNative: "₫",
    zeroDecimal: !0
  },
  VUV: {
    code: "VUV",
    decimalDigits: 0,
    name: "Vanuatu Vatu",
    namePlural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbolNative: "VT",
    zeroDecimal: !0
  },
  WST: {
    code: "WST",
    decimalDigits: 2,
    name: "Samoan Tala",
    namePlural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbolNative: "WS$",
    zeroDecimal: !1
  },
  XAF: {
    code: "XAF",
    decimalDigits: 0,
    name: "CFA Franc BEAC",
    namePlural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbolNative: "FCFA",
    zeroDecimal: !0
  },
  XCD: {
    code: "XCD",
    decimalDigits: 2,
    name: "East Caribbean Dollar",
    namePlural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  XOF: {
    code: "XOF",
    decimalDigits: 0,
    name: "CFA Franc BCEAO",
    namePlural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbolNative: "CFA",
    zeroDecimal: !0
  },
  XPF: {
    code: "XPF",
    decimalDigits: 0,
    name: "CFP Franc",
    namePlural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbolNative: "FCFP",
    zeroDecimal: !0
  },
  YER: {
    code: "YER",
    decimalDigits: 0,
    name: "Yemeni Rial",
    namePlural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    zeroDecimal: !1
  },
  ZAR: {
    code: "ZAR",
    decimalDigits: 2,
    name: "South African Rand",
    namePlural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbolNative: "R",
    zeroDecimal: !1
  },
  ZMK: {
    code: "ZMK",
    decimalDigits: 0,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    zeroDecimal: !0
  },
  ZMW: {
    code: "ZMW",
    decimalDigits: 2,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbolNative: "K",
    zeroDecimal: !1
  },
  ZWL: {
    code: "ZWL",
    decimalDigits: 0,
    name: "Zimbabwean Dollar",
    namePlural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbolNative: "ZWL$",
    zeroDecimal: !0
  }
}, er = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BHD",
  "BGN",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "STD",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW"
  /* ZMW */
];
Object.values(aa).filter((e) => !e.deprecated).map((e) => e.code);
const ar = Qt(aa, er);
Object.values(aa).filter(
  (e) => e.zeroDecimal && e.code in ar
).map((e) => e.code);
const nr = {
  AD: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "376",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png",
    iso2: "AD",
    name: "Andorra",
    priority: 0,
    timezone: "Europe/Andorra"
  },
  AE: {
    areaCodes: null,
    currency: t.AED,
    dialCode: "971",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png",
    iso2: "AE",
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    priority: 0,
    timezone: "Asia/Dubai"
  },
  AF: {
    areaCodes: null,
    currency: t.AFN,
    dialCode: "93",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png",
    iso2: "AF",
    name: "Afghanistan (‫افغانستان‬‎)",
    priority: 0,
    timezone: "Asia/Kabul"
  },
  AG: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png",
    iso2: "AG",
    name: "Antigua and Barbuda",
    priority: 0,
    timezone: "America/Antigua"
  },
  AI: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png",
    iso2: "AI",
    name: "Anguilla",
    priority: 0,
    timezone: "America/Anguilla"
  },
  AL: {
    areaCodes: null,
    currency: t.ALL,
    dialCode: "355",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png",
    iso2: "AL",
    name: "Albania (Shqipëri)",
    priority: 0,
    timezone: "Europe/Tirane"
  },
  AM: {
    areaCodes: null,
    currency: t.AMD,
    dialCode: "374",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png",
    iso2: "AM",
    name: "Armenia (Հայաստան)",
    priority: 0,
    timezone: "Asia/Yerevan"
  },
  AO: {
    areaCodes: null,
    currency: t.AOA,
    dialCode: "244",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png",
    iso2: "AO",
    name: "Angola",
    priority: 0,
    timezone: "Africa/Luanda"
  },
  AR: {
    areaCodes: null,
    currency: t.ARS,
    dialCode: "54",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png",
    iso2: "AR",
    name: "Argentina",
    priority: 0,
    timezone: "America/Argentina/Cordoba"
  },
  AS: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1684",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png",
    iso2: "AS",
    name: "American Samoa",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  AT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "43",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png",
    iso2: "AT",
    name: "Austria (Österreich)",
    priority: 0,
    timezone: "Europe/Vienna"
  },
  AU: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png",
    iso2: "AU",
    name: "Australia",
    priority: 0,
    timezone: "Australia/Darwin"
  },
  AW: {
    areaCodes: null,
    currency: t.AWG,
    dialCode: "297",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png",
    iso2: "AW",
    name: "Aruba",
    priority: 0,
    timezone: "America/Aruba"
  },
  AX: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png",
    iso2: "AX",
    name: "Åland Islands",
    priority: 1,
    timezone: "Europe/Helsinki"
  },
  AZ: {
    areaCodes: null,
    currency: t.AZN,
    dialCode: "994",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png",
    iso2: "AZ",
    name: "Azerbaijan (Azərbaycan)",
    priority: 0,
    timezone: "Asia/Baku"
  },
  BA: {
    areaCodes: null,
    currency: t.BAM,
    dialCode: "387",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png",
    iso2: "BA",
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    priority: 0,
    timezone: "Europe/Sarajevo"
  },
  BB: {
    areaCodes: null,
    currency: t.BBD,
    dialCode: "1246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png",
    iso2: "BB",
    name: "Barbados",
    priority: 0,
    timezone: "America/Barbados"
  },
  BD: {
    areaCodes: null,
    currency: t.BDT,
    dialCode: "880",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png",
    iso2: "BD",
    name: "Bangladesh (বাংলাদেশ)",
    priority: 0,
    timezone: "Asia/Dhaka"
  },
  BE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "32",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png",
    iso2: "BE",
    name: "Belgium (België)",
    priority: 0,
    timezone: "Europe/Brussels"
  },
  BF: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "226",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png",
    iso2: "BF",
    name: "Burkina Faso",
    priority: 0,
    timezone: "Africa/Ouagadougou"
  },
  BG: {
    areaCodes: null,
    currency: t.BGN,
    dialCode: "359",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png",
    iso2: "BG",
    name: "Bulgaria (България)",
    priority: 0,
    timezone: "Europe/Sofia"
  },
  BH: {
    areaCodes: null,
    currency: t.BHD,
    dialCode: "973",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png",
    iso2: "BH",
    name: "Bahrain (‫البحرين‬‎)",
    priority: 0,
    timezone: "Asia/Bahrain"
  },
  BI: {
    areaCodes: null,
    currency: t.BIF,
    dialCode: "257",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png",
    iso2: "BI",
    name: "Burundi (Uburundi)",
    priority: 0,
    timezone: "Africa/Bujumbura"
  },
  BJ: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "229",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png",
    iso2: "BJ",
    name: "Benin (Bénin)",
    priority: 0,
    timezone: "Africa/Porto-Novo"
  },
  BL: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png",
    iso2: "BL",
    name: "Saint Barthélemy",
    priority: 1,
    timezone: "America/St_Barthelemy"
  },
  BM: {
    areaCodes: null,
    currency: t.BMD,
    dialCode: "1441",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png",
    iso2: "BM",
    name: "Bermuda",
    priority: 0,
    timezone: "Atlantic/Bermuda"
  },
  BN: {
    areaCodes: null,
    currency: t.BND,
    dialCode: "673",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png",
    iso2: "BN",
    name: "Brunei",
    priority: 0,
    timezone: "Asia/Brunei"
  },
  BO: {
    areaCodes: null,
    currency: t.BOB,
    dialCode: "591",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png",
    iso2: "BO",
    name: "Bolivia",
    priority: 0,
    timezone: "America/La_Paz"
  },
  BQ: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png",
    iso2: "BQ",
    name: "Caribbean Netherlands",
    priority: 1,
    timezone: "America/Kralendijk"
  },
  BR: {
    areaCodes: null,
    currency: t.BRL,
    dialCode: "55",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png",
    iso2: "BR",
    name: "Brazil (Brasil)",
    priority: 0,
    timezone: "America/Cuiaba"
  },
  BS: {
    areaCodes: null,
    currency: t.BSD,
    dialCode: "1242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png",
    iso2: "BS",
    name: "Bahamas",
    priority: 0,
    timezone: "America/Nassau"
  },
  BT: {
    areaCodes: null,
    currency: t.BTN,
    dialCode: "975",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png",
    iso2: "BT",
    name: "Bhutan (འབྲུག)",
    priority: 0,
    timezone: "Asia/Thimphu"
  },
  BW: {
    areaCodes: null,
    currency: t.BWP,
    dialCode: "267",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png",
    iso2: "BW",
    name: "Botswana",
    priority: 0,
    timezone: "Africa/Gaborone"
  },
  BY: {
    areaCodes: null,
    currency: t.BYN,
    dialCode: "375",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png",
    iso2: "BY",
    name: "Belarus (Беларусь)",
    priority: 0,
    timezone: "Europe/Minsk"
  },
  BZ: {
    areaCodes: null,
    currency: t.BZD,
    dialCode: "501",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png",
    iso2: "BZ",
    name: "Belize",
    priority: 0,
    timezone: "America/Belize"
  },
  CA: {
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ],
    currency: t.CAD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png",
    iso2: "CA",
    name: "Canada",
    priority: 1,
    timezone: "America/Rankin_Inlet"
  },
  CC: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png",
    iso2: "CC",
    name: "Cocos (Keeling) Islands",
    priority: 1,
    timezone: "Indian/Cocos"
  },
  CD: {
    areaCodes: null,
    currency: t.CDF,
    dialCode: "243",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png",
    iso2: "CD",
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    priority: 0,
    timezone: "Africa/Lubumbashi"
  },
  CF: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "236",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png",
    iso2: "CF",
    name: "Central African Republic (République centrafricaine)",
    priority: 0,
    timezone: "Africa/Bangui"
  },
  CG: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png",
    iso2: "CG",
    name: "Congo (Republic) (Congo-Brazzaville)",
    priority: 0,
    timezone: "Africa/Brazzaville"
  },
  CH: {
    areaCodes: null,
    currency: t.CHF,
    dialCode: "41",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png",
    iso2: "CH",
    name: "Switzerland (Schweiz)",
    priority: 0,
    timezone: "Europe/Zurich"
  },
  CI: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "225",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png",
    iso2: "CI",
    name: "Côte d’Ivoire",
    priority: 0,
    timezone: "Africa/Abidjan"
  },
  CK: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "682",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png",
    iso2: "CK",
    name: "Cook Islands",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  CL: {
    areaCodes: null,
    currency: t.CLP,
    dialCode: "56",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png",
    iso2: "CL",
    name: "Chile",
    priority: 0,
    timezone: "America/Santiago"
  },
  CM: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "237",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png",
    iso2: "CM",
    name: "Cameroon (Cameroun)",
    priority: 0,
    timezone: "Africa/Douala"
  },
  CN: {
    areaCodes: null,
    currency: t.CNY,
    dialCode: "86",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png",
    iso2: "CN",
    name: "China (中国)",
    priority: 0,
    timezone: "Asia/Shanghai"
  },
  CO: {
    areaCodes: null,
    currency: t.COP,
    dialCode: "57",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png",
    iso2: "CO",
    name: "Colombia",
    priority: 0,
    timezone: "America/Bogota"
  },
  CR: {
    areaCodes: null,
    currency: t.CRC,
    dialCode: "506",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png",
    iso2: "CR",
    name: "Costa Rica",
    priority: 0,
    timezone: "America/Costa_Rica"
  },
  CU: {
    areaCodes: null,
    currency: t.CUP,
    dialCode: "53",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png",
    iso2: "CU",
    name: "Cuba",
    priority: 0,
    timezone: "America/Havana"
  },
  CV: {
    areaCodes: null,
    currency: t.CVE,
    dialCode: "238",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png",
    iso2: "CV",
    name: "Cape Verde (Kabu Verdi)",
    priority: 0,
    timezone: "Atlantic/Cape_Verde"
  },
  CW: {
    areaCodes: null,
    currency: t.ANG,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png",
    iso2: "CW",
    name: "Curaçao",
    priority: 0,
    timezone: "America/Curacao"
  },
  CX: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png",
    iso2: "CX",
    name: "Christmas Island",
    priority: 2,
    timezone: "Indian/Christmas"
  },
  CY: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "357",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png",
    iso2: "CY",
    name: "Cyprus (Κύπρος)",
    priority: 0,
    timezone: "Asia/Nicosia"
  },
  CZ: {
    areaCodes: null,
    currency: t.CZK,
    dialCode: "420",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png",
    iso2: "CZ",
    name: "Czech Republic (Česká republika)",
    priority: 0,
    timezone: "Europe/Prague"
  },
  DE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "49",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png",
    iso2: "DE",
    name: "Germany (Deutschland)",
    priority: 0,
    timezone: "Europe/Berlin"
  },
  DJ: {
    areaCodes: null,
    currency: t.DJF,
    dialCode: "253",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png",
    iso2: "DJ",
    name: "Djibouti",
    priority: 0,
    timezone: "Africa/Djibouti"
  },
  DK: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "45",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png",
    iso2: "DK",
    name: "Denmark (Danmark)",
    priority: 0,
    timezone: "Europe/Copenhagen"
  },
  DM: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1767",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png",
    iso2: "DM",
    name: "Dominica",
    priority: 0,
    timezone: "America/Dominica"
  },
  DO: {
    areaCodes: ["809", "829", "849"],
    currency: t.DOP,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png",
    iso2: "DO",
    name: "Dominican Republic (República Dominicana)",
    priority: 2,
    timezone: "America/Santo_Domingo"
  },
  DZ: {
    areaCodes: null,
    currency: t.DZD,
    dialCode: "213",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png",
    iso2: "DZ",
    name: "Algeria (‫الجزائر‬‎)",
    priority: 0,
    timezone: "Africa/Algiers"
  },
  EC: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "593",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png",
    iso2: "EC",
    name: "Ecuador",
    priority: 0,
    timezone: "America/Guayaquil"
  },
  EE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "372",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png",
    iso2: "EE",
    name: "Estonia (Eesti)",
    priority: 0,
    timezone: "Europe/Tallinn"
  },
  EG: {
    areaCodes: null,
    currency: t.EGP,
    dialCode: "20",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png",
    iso2: "EG",
    name: "Egypt (‫مصر‬‎)",
    priority: 0,
    timezone: "Africa/Cairo"
  },
  EH: {
    areaCodes: null,
    currency: t.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png",
    iso2: "EH",
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    priority: 1,
    timezone: "Africa/El_Aaiun"
  },
  ER: {
    areaCodes: null,
    currency: t.ERN,
    dialCode: "291",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png",
    iso2: "ER",
    name: "Eritrea",
    priority: 0,
    timezone: "Africa/Asmara"
  },
  ES: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "34",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png",
    iso2: "ES",
    name: "Spain (España)",
    priority: 0,
    timezone: "Europe/Madrid"
  },
  ET: {
    areaCodes: null,
    currency: t.ETB,
    dialCode: "251",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png",
    iso2: "ET",
    name: "Ethiopia",
    priority: 0,
    timezone: "Africa/Addis_Ababa"
  },
  FI: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png",
    iso2: "FI",
    name: "Finland (Suomi)",
    priority: 0,
    timezone: "Europe/Helsinki"
  },
  FJ: {
    areaCodes: null,
    currency: t.FJD,
    dialCode: "679",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png",
    iso2: "FJ",
    name: "Fiji",
    priority: 0,
    timezone: "Pacific/Fiji"
  },
  FK: {
    areaCodes: null,
    currency: t.FKP,
    dialCode: "500",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png",
    iso2: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    priority: 0,
    timezone: "Atlantic/Stanley"
  },
  FM: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "691",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png",
    iso2: "FM",
    name: "Micronesia",
    priority: 0,
    timezone: "Etc/GMT-10"
  },
  FO: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "298",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png",
    iso2: "FO",
    name: "Faroe Islands (Føroyar)",
    priority: 0,
    timezone: "Atlantic/Faroe"
  },
  FR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "33",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png",
    iso2: "FR",
    name: "France",
    priority: 0,
    timezone: "Europe/Paris"
  },
  GA: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "241",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png",
    iso2: "GA",
    name: "Gabon",
    priority: 0,
    timezone: "Africa/Libreville"
  },
  GB: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png",
    iso2: "GB",
    name: "United Kingdom",
    priority: 0,
    timezone: "Etc/GMT"
  },
  GD: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1473",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png",
    iso2: "GD",
    name: "Grenada",
    priority: 0,
    timezone: "America/Grenada"
  },
  GE: {
    areaCodes: null,
    currency: t.GEL,
    dialCode: "995",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png",
    iso2: "GE",
    name: "Georgia (საქართველო)",
    priority: 0,
    timezone: "Asia/Tbilisi"
  },
  GF: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "594",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png",
    iso2: "GF",
    name: "French Guiana (Guyane française)",
    priority: 0,
    timezone: "America/Cayenne"
  },
  GG: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png",
    iso2: "GG",
    name: "Guernsey",
    priority: 1,
    timezone: "Europe/Guernsey"
  },
  GH: {
    areaCodes: null,
    currency: t.GHS,
    dialCode: "233",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png",
    iso2: "GH",
    name: "Ghana (Gaana)",
    priority: 0,
    timezone: "Africa/Accra"
  },
  GI: {
    areaCodes: null,
    currency: t.GIP,
    dialCode: "350",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png",
    iso2: "GI",
    name: "Gibraltar",
    priority: 0,
    timezone: "Europe/Gibraltar"
  },
  GL: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "299",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png",
    iso2: "GL",
    name: "Greenland (Kalaallit Nunaat)",
    priority: 0,
    timezone: "America/Godthab"
  },
  GM: {
    areaCodes: null,
    currency: t.GMD,
    dialCode: "220",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png",
    iso2: "GM",
    name: "Gambia",
    priority: 0,
    timezone: "Africa/Banjul"
  },
  GN: {
    areaCodes: null,
    currency: t.GNF,
    dialCode: "224",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png",
    iso2: "GN",
    name: "Guinea (Guinée)",
    priority: 0,
    timezone: "Africa/Conakry"
  },
  GP: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png",
    iso2: "GP",
    name: "Guadeloupe",
    priority: 0,
    timezone: "America/Guadeloupe"
  },
  GQ: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "240",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png",
    iso2: "GQ",
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    priority: 0,
    timezone: "Africa/Malabo"
  },
  GR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "30",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png",
    iso2: "GR",
    name: "Greece (Ελλάδα)",
    priority: 0,
    timezone: "Europe/Athens"
  },
  GT: {
    areaCodes: null,
    currency: t.GTQ,
    dialCode: "502",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png",
    iso2: "GT",
    name: "Guatemala",
    priority: 0,
    timezone: "America/Guatemala"
  },
  GU: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1671",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png",
    iso2: "GU",
    name: "Guam",
    priority: 0,
    timezone: "Pacific/Guam"
  },
  GW: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "245",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png",
    iso2: "GW",
    name: "Guinea-Bissau (Guiné Bissau)",
    priority: 0,
    timezone: "Africa/Bissau"
  },
  GY: {
    areaCodes: null,
    currency: t.GYD,
    dialCode: "592",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png",
    iso2: "GY",
    name: "Guyana",
    priority: 0,
    timezone: "America/Guyana"
  },
  HK: {
    areaCodes: null,
    currency: t.HKD,
    dialCode: "852",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png",
    iso2: "HK",
    name: "Hong Kong (香港)",
    priority: 0,
    timezone: "Asia/Hong_Kong"
  },
  HN: {
    areaCodes: null,
    currency: t.HNL,
    dialCode: "504",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png",
    iso2: "HN",
    name: "Honduras",
    priority: 0,
    timezone: "America/Tegucigalpa"
  },
  HR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "385",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png",
    iso2: "HR",
    name: "Croatia (Hrvatska)",
    priority: 0,
    timezone: "Europe/Zagreb"
  },
  HT: {
    areaCodes: null,
    currency: t.HTG,
    dialCode: "509",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png",
    iso2: "HT",
    name: "Haiti",
    priority: 0,
    timezone: "America/Port-au-Prince"
  },
  HU: {
    areaCodes: null,
    currency: t.HUF,
    dialCode: "36",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png",
    iso2: "HU",
    name: "Hungary (Magyarország)",
    priority: 0,
    timezone: "Europe/Budapest"
  },
  ID: {
    areaCodes: null,
    currency: t.IDR,
    dialCode: "62",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png",
    iso2: "ID",
    name: "Indonesia",
    priority: 0,
    timezone: "Asia/Makassar"
  },
  IE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "353",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png",
    iso2: "IE",
    name: "Ireland",
    priority: 0,
    timezone: "Europe/Dublin"
  },
  IL: {
    areaCodes: null,
    currency: t.ILS,
    dialCode: "972",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png",
    iso2: "IL",
    name: "Israel (‫ישראל‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  IM: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png",
    iso2: "IM",
    name: "Isle of Man",
    priority: 2,
    timezone: "Europe/Isle_of_Man"
  },
  IN: {
    areaCodes: null,
    currency: t.INR,
    dialCode: "91",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png",
    iso2: "IN",
    name: "India (भारत)",
    priority: 0,
    timezone: "Asia/Kolkata"
  },
  IO: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png",
    iso2: "IO",
    name: "British Indian Ocean Territory",
    priority: 0,
    timezone: "Etc/GMT-5"
  },
  IQ: {
    areaCodes: null,
    currency: t.IQD,
    dialCode: "964",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png",
    iso2: "IQ",
    name: "Iraq (‫العراق‬‎)",
    priority: 0,
    timezone: "Asia/Baghdad"
  },
  IR: {
    areaCodes: null,
    currency: t.IRR,
    dialCode: "98",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png",
    iso2: "IR",
    name: "Iran (‫ایران‬‎)",
    priority: 0,
    timezone: "Asia/Tehran"
  },
  IS: {
    areaCodes: null,
    currency: t.ISK,
    dialCode: "354",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png",
    iso2: "IS",
    name: "Iceland (Ísland)",
    priority: 0,
    timezone: "Atlantic/Reykjavik"
  },
  IT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png",
    iso2: "IT",
    name: "Italy (Italia)",
    priority: 0,
    timezone: "Europe/Rome"
  },
  JE: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png",
    iso2: "JE",
    name: "Jersey",
    priority: 3,
    timezone: "Europe/Jersey"
  },
  JM: {
    areaCodes: null,
    currency: t.JMD,
    dialCode: "1876",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png",
    iso2: "JM",
    name: "Jamaica",
    priority: 0,
    timezone: "America/Jamaica"
  },
  JO: {
    areaCodes: null,
    currency: t.JOD,
    dialCode: "962",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png",
    iso2: "JO",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
    timezone: "Asia/Amman"
  },
  JP: {
    areaCodes: null,
    currency: t.JPY,
    dialCode: "81",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png",
    iso2: "JP",
    name: "Japan (日本)",
    priority: 0,
    timezone: "Asia/Tokyo"
  },
  KE: {
    areaCodes: null,
    currency: t.KES,
    dialCode: "254",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png",
    iso2: "KE",
    name: "Kenya",
    priority: 0,
    timezone: "Africa/Nairobi"
  },
  KG: {
    areaCodes: null,
    currency: t.KGS,
    dialCode: "996",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png",
    iso2: "KG",
    name: "Kyrgyzstan (Кыргызстан)",
    priority: 0,
    timezone: "Asia/Bishkek"
  },
  KH: {
    areaCodes: null,
    currency: t.KHR,
    dialCode: "855",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png",
    iso2: "KH",
    name: "Cambodia (កម្ពុជា)",
    priority: 0,
    timezone: "Asia/Phnom_Penh"
  },
  KI: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "686",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png",
    iso2: "KI",
    name: "Kiribati",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  KM: {
    areaCodes: null,
    currency: t.KMF,
    dialCode: "269",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png",
    iso2: "KM",
    name: "Comoros (‫جزر القمر‬‎)",
    priority: 0,
    timezone: "Indian/Comoro"
  },
  KN: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1869",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png",
    iso2: "KN",
    name: "Saint Kitts and Nevis",
    priority: 0,
    timezone: "America/St_Kitts"
  },
  KP: {
    areaCodes: null,
    currency: t.KPW,
    dialCode: "850",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png",
    iso2: "KP",
    name: "North Korea (조선 민주주의 인민 공화국)",
    priority: 0,
    timezone: "Asia/Pyongyang"
  },
  KR: {
    areaCodes: null,
    currency: t.KRW,
    dialCode: "82",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png",
    iso2: "KR",
    name: "South Korea (대한민국)",
    priority: 0,
    timezone: "Asia/Seoul"
  },
  KW: {
    areaCodes: null,
    currency: t.KWD,
    dialCode: "965",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png",
    iso2: "KW",
    name: "Kuwait (‫الكويت‬‎)",
    priority: 0,
    timezone: "Asia/Kuwait"
  },
  KY: {
    areaCodes: null,
    currency: t.KYD,
    dialCode: "1345",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png",
    iso2: "KY",
    name: "Cayman Islands",
    priority: 0,
    timezone: "Etc/GMT+5"
  },
  KZ: {
    areaCodes: null,
    currency: t.KZT,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png",
    iso2: "KZ",
    name: "Kazakhstan (Казахстан)",
    priority: 1,
    timezone: "Asia/Almaty"
  },
  LA: {
    areaCodes: null,
    currency: t.LAK,
    dialCode: "856",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png",
    iso2: "LA",
    name: "Laos (ລາວ)",
    priority: 0,
    timezone: "Asia/Vientiane"
  },
  LB: {
    areaCodes: null,
    currency: t.LBP,
    dialCode: "961",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png",
    iso2: "LB",
    name: "Lebanon (‫لبنان‬‎)",
    priority: 0,
    timezone: "Asia/Beirut"
  },
  LC: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1758",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png",
    iso2: "LC",
    name: "Saint Lucia",
    priority: 0,
    timezone: "America/St_Lucia"
  },
  LI: {
    areaCodes: null,
    currency: t.CHF,
    dialCode: "423",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png",
    iso2: "LI",
    name: "Liechtenstein",
    priority: 0,
    timezone: "Europe/Vaduz"
  },
  LK: {
    areaCodes: null,
    currency: t.LKR,
    dialCode: "94",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png",
    iso2: "LK",
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    priority: 0,
    timezone: "Asia/Colombo"
  },
  LR: {
    areaCodes: null,
    currency: t.LRD,
    dialCode: "231",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png",
    iso2: "LR",
    name: "Liberia",
    priority: 0,
    timezone: "Africa/Monrovia"
  },
  LS: {
    areaCodes: null,
    currency: t.LSL,
    dialCode: "266",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png",
    iso2: "LS",
    name: "Lesotho",
    priority: 0,
    timezone: "Africa/Maseru"
  },
  LT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "370",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png",
    iso2: "LT",
    name: "Lithuania (Lietuva)",
    priority: 0,
    timezone: "Europe/Vilnius"
  },
  LU: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "352",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png",
    iso2: "LU",
    name: "Luxembourg",
    priority: 0,
    timezone: "Europe/Luxembourg"
  },
  LV: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "371",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png",
    iso2: "LV",
    name: "Latvia (Latvija)",
    priority: 0,
    timezone: "Europe/Riga"
  },
  LY: {
    areaCodes: null,
    currency: t.LYD,
    dialCode: "218",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png",
    iso2: "LY",
    name: "Libya (‫ليبيا‬‎)",
    priority: 0,
    timezone: "Africa/Tripoli"
  },
  MA: {
    areaCodes: null,
    currency: t.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png",
    iso2: "MA",
    name: "Morocco (‫المغرب‬‎)",
    priority: 0,
    timezone: "Africa/Casablanca"
  },
  MC: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "377",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png",
    iso2: "MC",
    name: "Monaco",
    priority: 0,
    timezone: "Europe/Paris"
  },
  MD: {
    areaCodes: null,
    currency: t.MDL,
    dialCode: "373",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png",
    iso2: "MD",
    name: "Moldova (Republica Moldova)",
    priority: 0,
    timezone: "Europe/Chisinau"
  },
  ME: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "382",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png",
    iso2: "ME",
    name: "Montenegro (Crna Gora)",
    priority: 0,
    timezone: "Europe/Podgorica"
  },
  MF: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png",
    iso2: "MF",
    name: "Saint Martin (Saint-Martin (partie française))",
    priority: 2,
    timezone: "America/Marigot"
  },
  MG: {
    areaCodes: null,
    currency: t.MGA,
    dialCode: "261",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png",
    iso2: "MG",
    name: "Madagascar (Madagasikara)",
    priority: 0,
    timezone: "Indian/Antananarivo"
  },
  MH: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "692",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png",
    iso2: "MH",
    name: "Marshall Islands",
    priority: 0,
    timezone: "Etc/GMT-11"
  },
  MK: {
    areaCodes: null,
    currency: t.MKD,
    dialCode: "389",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png",
    iso2: "MK",
    name: "Macedonia (FYROM) (Македонија)",
    priority: 0,
    timezone: "Europe/Skopje"
  },
  ML: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "223",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png",
    iso2: "ML",
    name: "Mali",
    priority: 0,
    timezone: "Africa/Bamako"
  },
  MM: {
    areaCodes: null,
    currency: t.MMK,
    dialCode: "95",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png",
    iso2: "MM",
    name: "Myanmar (Burma) (မြန်မာ)",
    priority: 0,
    timezone: "Asia/Yangon"
  },
  MN: {
    areaCodes: null,
    currency: t.MNT,
    dialCode: "976",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png",
    iso2: "MN",
    name: "Mongolia (Монгол)",
    priority: 0,
    timezone: "Asia/Ulaanbaatar"
  },
  MO: {
    areaCodes: null,
    currency: t.MOP,
    dialCode: "853",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png",
    iso2: "MO",
    name: "Macau (澳門)",
    priority: 0,
    timezone: "Asia/Macau"
  },
  MP: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png",
    iso2: "MP",
    name: "Northern Mariana Islands",
    priority: 0,
    timezone: "Pacific/Saipan"
  },
  MQ: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "596",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png",
    iso2: "MQ",
    name: "Martinique",
    priority: 0,
    timezone: "America/Martinique"
  },
  MR: {
    areaCodes: null,
    currency: t.MRU,
    dialCode: "222",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png",
    iso2: "MR",
    name: "Mauritania (‫موريتانيا‬‎)",
    priority: 0,
    timezone: "Africa/Nouakchott"
  },
  MS: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1664",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png",
    iso2: "MS",
    name: "Montserrat",
    priority: 0,
    timezone: "America/Montserrat"
  },
  MT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "356",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png",
    iso2: "MT",
    name: "Malta",
    priority: 0,
    timezone: "Europe/Malta"
  },
  MU: {
    areaCodes: null,
    currency: t.MUR,
    dialCode: "230",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png",
    iso2: "MU",
    name: "Mauritius (Moris)",
    priority: 0,
    timezone: "Indian/Mauritius"
  },
  MV: {
    areaCodes: null,
    currency: t.MVR,
    dialCode: "960",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png",
    iso2: "MV",
    name: "Maldives",
    priority: 0,
    timezone: "Indian/Maldives"
  },
  MW: {
    areaCodes: null,
    currency: t.MWK,
    dialCode: "265",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png",
    iso2: "MW",
    name: "Malawi",
    priority: 0,
    timezone: "Africa/Blantyre"
  },
  MX: {
    areaCodes: null,
    currency: t.MXN,
    dialCode: "52",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png",
    iso2: "MX",
    name: "Mexico (México)",
    priority: 0,
    timezone: "America/Mexico_City"
  },
  MY: {
    areaCodes: null,
    currency: t.MYR,
    dialCode: "60",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png",
    iso2: "MY",
    name: "Malaysia",
    priority: 0,
    timezone: "Asia/Kuching"
  },
  MZ: {
    areaCodes: null,
    currency: t.MZN,
    dialCode: "258",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png",
    iso2: "MZ",
    name: "Mozambique (Moçambique)",
    priority: 0,
    timezone: "Africa/Maputo"
  },
  NA: {
    areaCodes: null,
    currency: t.NAD,
    dialCode: "264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png",
    iso2: "NA",
    name: "Namibia (Namibië)",
    priority: 0,
    timezone: "Africa/Windhoek"
  },
  NC: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "687",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png",
    iso2: "NC",
    name: "New Caledonia (Nouvelle-Calédonie)",
    priority: 0,
    timezone: "Pacific/Noumea"
  },
  NE: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "227",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png",
    iso2: "NE",
    name: "Niger (Nijar)",
    priority: 0,
    timezone: "Africa/Niamey"
  },
  NF: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "672",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png",
    iso2: "NF",
    name: "Norfolk Island",
    priority: 0,
    timezone: "Pacific/Norfolk"
  },
  NG: {
    areaCodes: null,
    currency: t.NGN,
    dialCode: "234",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png",
    iso2: "NG",
    name: "Nigeria",
    priority: 0,
    timezone: "Africa/Lagos"
  },
  NI: {
    areaCodes: null,
    currency: t.NIO,
    dialCode: "505",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png",
    iso2: "NI",
    name: "Nicaragua",
    priority: 0,
    timezone: "America/Managua"
  },
  NL: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "31",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png",
    iso2: "NL",
    name: "Netherlands (Nederland)",
    priority: 0,
    timezone: "Europe/Amsterdam"
  },
  NO: {
    areaCodes: null,
    currency: t.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png",
    iso2: "NO",
    name: "Norway (Norge)",
    priority: 0,
    timezone: "Europe/Oslo"
  },
  NP: {
    areaCodes: null,
    currency: t.NPR,
    dialCode: "977",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png",
    iso2: "NP",
    name: "Nepal (नेपाल)",
    priority: 0,
    timezone: "Asia/Kathmandu"
  },
  NR: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "674",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png",
    iso2: "NR",
    name: "Nauru",
    priority: 0,
    timezone: "Pacific/Nauru"
  },
  NU: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "683",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png",
    iso2: "NU",
    name: "Niue",
    priority: 0,
    timezone: "Pacific/Niue"
  },
  NZ: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "64",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png",
    iso2: "NZ",
    name: "New Zealand",
    priority: 0,
    timezone: "Pacific/Auckland"
  },
  OM: {
    areaCodes: null,
    currency: t.OMR,
    dialCode: "968",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png",
    iso2: "OM",
    name: "Oman (‫عُمان‬‎)",
    priority: 0,
    timezone: "Asia/Muscat"
  },
  PA: {
    areaCodes: null,
    currency: t.PAB,
    dialCode: "507",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png",
    iso2: "PA",
    name: "Panama (Panamá)",
    priority: 0,
    timezone: "America/Panama"
  },
  PE: {
    areaCodes: null,
    currency: t.PEN,
    dialCode: "51",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png",
    iso2: "PE",
    name: "Peru (Perú)",
    priority: 0,
    timezone: "America/Lima"
  },
  PF: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "689",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png",
    iso2: "PF",
    name: "French Polynesia (Polynésie française)",
    priority: 0,
    timezone: "Etc/GMT+9"
  },
  PG: {
    areaCodes: null,
    currency: t.PGK,
    dialCode: "675",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png",
    iso2: "PG",
    name: "Papua New Guinea",
    priority: 0,
    timezone: "Pacific/Port_Moresby"
  },
  PH: {
    areaCodes: null,
    currency: t.PHP,
    dialCode: "63",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png",
    iso2: "PH",
    name: "Philippines",
    priority: 0,
    timezone: "Asia/Manila"
  },
  PK: {
    areaCodes: null,
    currency: t.PKR,
    dialCode: "92",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png",
    iso2: "PK",
    name: "Pakistan (‫پاکستان‬‎)",
    priority: 0,
    timezone: "Asia/Karachi"
  },
  PL: {
    areaCodes: null,
    currency: t.PLN,
    dialCode: "48",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png",
    iso2: "PL",
    name: "Poland (Polska)",
    priority: 0,
    timezone: "Europe/Warsaw"
  },
  PM: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "508",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png",
    iso2: "PM",
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    priority: 0,
    timezone: "America/Miquelon"
  },
  PR: {
    areaCodes: ["787", "939"],
    currency: t.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png",
    iso2: "PR",
    name: "Puerto Rico",
    priority: 3,
    timezone: "America/Puerto_Rico"
  },
  PS: {
    areaCodes: null,
    currency: t.ILS,
    dialCode: "970",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png",
    iso2: "PS",
    name: "Palestine (‫فلسطين‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  PT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "351",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png",
    iso2: "PT",
    name: "Portugal",
    priority: 0,
    timezone: "Europe/Lisbon"
  },
  PW: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "680",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png",
    iso2: "PW",
    name: "Palau",
    priority: 0,
    timezone: "Etc/GMT-9"
  },
  PY: {
    areaCodes: null,
    currency: t.PYG,
    dialCode: "595",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png",
    iso2: "PY",
    name: "Paraguay",
    priority: 0,
    timezone: "America/Asuncion"
  },
  QA: {
    areaCodes: null,
    currency: t.QAR,
    dialCode: "974",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png",
    iso2: "QA",
    name: "Qatar (‫قطر‬‎)",
    priority: 0,
    timezone: "Asia/Qatar"
  },
  RE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png",
    iso2: "RE",
    name: "Réunion (La Réunion)",
    priority: 0,
    timezone: "Indian/Reunion"
  },
  RO: {
    areaCodes: null,
    currency: t.RON,
    dialCode: "40",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png",
    iso2: "RO",
    name: "Romania (România)",
    priority: 0,
    timezone: "Europe/Bucharest"
  },
  RS: {
    areaCodes: null,
    currency: t.RSD,
    dialCode: "381",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png",
    iso2: "RS",
    name: "Serbia (Србија)",
    priority: 0,
    timezone: "Europe/Belgrade"
  },
  RU: {
    areaCodes: null,
    currency: t.RUB,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png",
    iso2: "RU",
    name: "Russia (Россия)",
    priority: 0,
    timezone: "Asia/Krasnoyarsk"
  },
  RW: {
    areaCodes: null,
    currency: t.RWF,
    dialCode: "250",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png",
    iso2: "RW",
    name: "Rwanda",
    priority: 0,
    timezone: "Africa/Kigali"
  },
  SA: {
    areaCodes: null,
    currency: t.SAR,
    dialCode: "966",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png",
    iso2: "SA",
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    priority: 0,
    timezone: "Asia/Riyadh"
  },
  SB: {
    areaCodes: null,
    currency: t.SBD,
    dialCode: "677",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png",
    iso2: "SB",
    name: "Solomon Islands",
    priority: 0,
    timezone: "Pacific/Guadalcanal"
  },
  SC: {
    areaCodes: null,
    currency: t.SCR,
    dialCode: "248",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png",
    iso2: "SC",
    name: "Seychelles",
    priority: 0,
    timezone: "Indian/Mahe"
  },
  SD: {
    areaCodes: null,
    currency: t.SDG,
    dialCode: "249",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png",
    iso2: "SD",
    name: "Sudan (‫السودان‬‎)",
    priority: 0,
    timezone: "Africa/Khartoum"
  },
  SE: {
    areaCodes: null,
    currency: t.SEK,
    dialCode: "46",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png",
    iso2: "SE",
    name: "Sweden (Sverige)",
    priority: 0,
    timezone: "Europe/Stockholm"
  },
  SG: {
    areaCodes: null,
    currency: t.SGD,
    dialCode: "65",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png",
    iso2: "SG",
    name: "Singapore",
    priority: 0,
    timezone: "Asia/Singapore"
  },
  SH: {
    areaCodes: null,
    currency: t.SHP,
    dialCode: "290",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png",
    iso2: "SH",
    name: "Saint Helena",
    priority: 0,
    timezone: "Atlantic/St_Helena"
  },
  SI: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "386",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png",
    iso2: "SI",
    name: "Slovenia (Slovenija)",
    priority: 0,
    timezone: "Europe/Ljubljana"
  },
  SJ: {
    areaCodes: null,
    currency: t.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png",
    iso2: "SJ",
    name: "Svalbard and Jan Mayen",
    priority: 1,
    timezone: "Arctic/Longyearbyen"
  },
  SK: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "421",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png",
    iso2: "SK",
    name: "Slovakia (Slovensko)",
    priority: 0,
    timezone: "Europe/Bratislava"
  },
  SL: {
    areaCodes: null,
    currency: t.SLL,
    dialCode: "232",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png",
    iso2: "SL",
    name: "Sierra Leone",
    priority: 0,
    timezone: "Africa/Freetown"
  },
  SM: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "378",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png",
    iso2: "SM",
    name: "San Marino",
    priority: 0,
    timezone: "Europe/San_Marino"
  },
  SN: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "221",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png",
    iso2: "SN",
    name: "Senegal (Sénégal)",
    priority: 0,
    timezone: "Africa/Dakar"
  },
  SO: {
    areaCodes: null,
    currency: t.SOS,
    dialCode: "252",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png",
    iso2: "SO",
    name: "Somalia (Soomaaliya)",
    priority: 0,
    timezone: "Africa/Mogadishu"
  },
  SR: {
    areaCodes: null,
    currency: t.SRD,
    dialCode: "597",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png",
    iso2: "SR",
    name: "Suriname",
    priority: 0,
    timezone: "America/Paramaribo"
  },
  SS: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "211",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png",
    iso2: "SS",
    name: "South Sudan (‫جنوب السودان‬‎)",
    priority: 0,
    timezone: "Africa/Juba"
  },
  ST: {
    areaCodes: null,
    currency: t.STD,
    dialCode: "239",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png",
    iso2: "ST",
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    priority: 0,
    timezone: "Africa/Sao_Tome"
  },
  SV: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "503",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png",
    iso2: "SV",
    name: "El Salvador",
    priority: 0,
    timezone: "America/El_Salvador"
  },
  SX: {
    areaCodes: null,
    currency: t.ANG,
    dialCode: "1721",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png",
    iso2: "SX",
    name: "Sint Maarten",
    priority: 0,
    timezone: "America/Lower_Princes"
  },
  SY: {
    areaCodes: null,
    currency: t.SYP,
    dialCode: "963",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png",
    iso2: "SY",
    name: "Syria (‫سوريا‬‎)",
    priority: 0,
    timezone: "Asia/Damascus"
  },
  SZ: {
    areaCodes: null,
    currency: t.SZL,
    dialCode: "268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png",
    iso2: "SZ",
    name: "Swaziland",
    priority: 0,
    timezone: "Africa/Mbabane"
  },
  TC: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1649",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png",
    iso2: "TC",
    name: "Turks and Caicos Islands",
    priority: 0,
    timezone: "America/Grand_Turk"
  },
  TD: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "235",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png",
    iso2: "TD",
    name: "Chad (Tchad)",
    priority: 0,
    timezone: "Africa/Ndjamena"
  },
  TG: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "228",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png",
    iso2: "TG",
    name: "Togo",
    priority: 0,
    timezone: "Africa/Lome"
  },
  TH: {
    areaCodes: null,
    currency: t.THB,
    dialCode: "66",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png",
    iso2: "TH",
    name: "Thailand (ไทย)",
    priority: 0,
    timezone: "Asia/Bangkok"
  },
  TJ: {
    areaCodes: null,
    currency: t.TJS,
    dialCode: "992",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png",
    iso2: "TJ",
    name: "Tajikistan",
    priority: 0,
    timezone: "Asia/Dushanbe"
  },
  TK: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "690",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png",
    iso2: "TK",
    name: "Tokelau",
    priority: 0,
    timezone: "Pacific/Fakaofo"
  },
  TL: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png",
    iso2: "TL",
    name: "Timor-Leste",
    priority: 0,
    timezone: "Asia/Dili"
  },
  TM: {
    areaCodes: null,
    currency: t.TMT,
    dialCode: "993",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png",
    iso2: "TM",
    name: "Turkmenistan",
    priority: 0,
    timezone: "Asia/Ashgabat"
  },
  TN: {
    areaCodes: null,
    currency: t.TND,
    dialCode: "216",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png",
    iso2: "TN",
    name: "Tunisia (‫تونس‬‎)",
    priority: 0,
    timezone: "Africa/Tunis"
  },
  TO: {
    areaCodes: null,
    currency: t.TOP,
    dialCode: "676",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png",
    iso2: "TO",
    name: "Tonga",
    priority: 0,
    timezone: "Pacific/Tongatapu"
  },
  TR: {
    areaCodes: null,
    currency: t.TRY,
    dialCode: "90",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png",
    iso2: "TR",
    name: "Turkey (Türkiye)",
    priority: 0,
    timezone: "Europe/Istanbul"
  },
  TT: {
    areaCodes: null,
    currency: t.TTD,
    dialCode: "1868",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png",
    iso2: "TT",
    name: "Trinidad and Tobago",
    priority: 0,
    timezone: "America/Port_of_Spain"
  },
  TV: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "688",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png",
    iso2: "TV",
    name: "Tuvalu",
    priority: 0,
    timezone: "Etc/GMT-12"
  },
  TW: {
    areaCodes: null,
    currency: t.TWD,
    dialCode: "886",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png",
    iso2: "TW",
    name: "Taiwan (台灣)",
    priority: 0,
    timezone: "Asia/Taipei"
  },
  TZ: {
    areaCodes: null,
    currency: t.TZS,
    dialCode: "255",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png",
    iso2: "TZ",
    name: "Tanzania",
    priority: 0,
    timezone: "Africa/Dar_es_Salaam"
  },
  UA: {
    areaCodes: null,
    currency: t.UAH,
    dialCode: "380",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png",
    iso2: "UA",
    name: "Ukraine (Україна)",
    priority: 0,
    timezone: "Europe/Kiev"
  },
  UG: {
    areaCodes: null,
    currency: t.UGX,
    dialCode: "256",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png",
    iso2: "UG",
    name: "Uganda",
    priority: 0,
    timezone: "Africa/Kampala"
  },
  US: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png",
    iso2: "US",
    name: "United States",
    priority: 0,
    timezone: "America/Chicago"
  },
  UY: {
    areaCodes: null,
    currency: t.UYU,
    dialCode: "598",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png",
    iso2: "UY",
    name: "Uruguay",
    priority: 0,
    timezone: "America/Montevideo"
  },
  UZ: {
    areaCodes: null,
    currency: t.UZS,
    dialCode: "998",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png",
    iso2: "UZ",
    name: "Uzbekistan (Oʻzbekiston)",
    priority: 0,
    timezone: "Asia/Samarkand"
  },
  VA: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png",
    iso2: "VA",
    name: "Vatican City (Città del Vaticano)",
    priority: 1,
    timezone: "Europe/Rome"
  },
  VC: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1784",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png",
    iso2: "VC",
    name: "Saint Vincent and the Grenadines",
    priority: 0,
    timezone: "America/St_Vincent"
  },
  VE: {
    areaCodes: null,
    currency: t.VES,
    dialCode: "58",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png",
    iso2: "VE",
    name: "Venezuela",
    priority: 0,
    timezone: "America/Caracas"
  },
  VG: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1284",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png",
    iso2: "VG",
    name: "British Virgin Islands",
    priority: 0,
    timezone: "America/Tortola"
  },
  VI: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1340",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png",
    iso2: "VI",
    name: "U.S. Virgin Islands",
    priority: 0,
    timezone: "America/St_Thomas"
  },
  VN: {
    areaCodes: null,
    currency: t.VND,
    dialCode: "84",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png",
    iso2: "VN",
    name: "Vietnam (Việt Nam)",
    priority: 0,
    timezone: "Asia/Ho_Chi_Minh"
  },
  VU: {
    areaCodes: null,
    currency: t.VUV,
    dialCode: "678",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png",
    iso2: "VU",
    name: "Vanuatu",
    priority: 0,
    timezone: "Pacific/Efate"
  },
  WF: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "681",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png",
    iso2: "WF",
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    priority: 0,
    timezone: "Pacific/Wallis"
  },
  WS: {
    areaCodes: null,
    currency: t.WST,
    dialCode: "685",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png",
    iso2: "WS",
    name: "Samoa",
    priority: 0,
    timezone: "Pacific/Apia"
  },
  XK: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "383",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png",
    iso2: "XK",
    name: "Kosovo",
    priority: 0,
    timezone: "Europe/Rome"
  },
  YE: {
    areaCodes: null,
    currency: t.YER,
    dialCode: "967",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png",
    iso2: "YE",
    name: "Yemen (‫اليمن‬‎)",
    priority: 0,
    timezone: "Asia/Aden"
  },
  YT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png",
    iso2: "YT",
    name: "Mayotte",
    priority: 1,
    timezone: "Indian/Mayotte"
  },
  ZA: {
    areaCodes: null,
    currency: t.ZAR,
    dialCode: "27",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png",
    iso2: "ZA",
    name: "South Africa",
    priority: 0,
    timezone: "Africa/Johannesburg"
  },
  ZM: {
    areaCodes: null,
    currency: t.ZMK,
    dialCode: "260",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png",
    iso2: "ZM",
    name: "Zambia",
    priority: 0,
    timezone: "Africa/Lusaka"
  },
  ZW: {
    areaCodes: null,
    currency: t.ZWL,
    dialCode: "263",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png",
    iso2: "ZW",
    name: "Zimbabwe",
    priority: 0,
    timezone: "Africa/Harare"
  }
};
Object.values(nr).map(
  (e) => e.iso2
);
var We = /* @__PURE__ */ ((e) => (e.V1 = "v1", e))(We || {}), ne = /* @__PURE__ */ ((e) => (e.Production = "LIVE", e.Sandbox = "SANDBOX", e.Staging = "STAGING", e.CiCd = "CI-CD", e.Local = "LOCAL", e))(ne || {});
const ir = {
  LIVE: "https://booking-api.revolugo.com",
  SANDBOX: "https://booking-api.sandbox.revolugo.com",
  STAGING: "https://booking-api.staging.revolugo.com",
  "CI-CD": "https://booking-api.staging.revolugo.com",
  LOCAL: "http://127.0.0.1:3001"
};
var na = /* @__PURE__ */ ((e) => (e.HOTEL_ROOM_OFFERS = "HOTEL_ROOM_OFFERS", e.HOTEL_SEARCH_POLLING = "HOTEL_SEARCH_POLLING", e))(na || {}), Se = { exports: {} }, tr = Se.exports, Da;
function nn() {
  return Da || (Da = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(tr, function() {
      var n = 1e3, i = 6e4, r = 36e5, l = "millisecond", s = "second", u = "minute", d = "hour", f = "day", D = "week", R = "month", S = "quarter", w = "year", v = "date", h = "Invalid Date", M = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, O = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
        var o = ["th", "st", "nd", "rd"], c = A % 100;
        return "[" + A + (o[(c - 20) % 10] || o[c] || o[0]) + "]";
      } }, B = function(A, o, c) {
        var m = String(A);
        return !m || m.length >= o ? A : "" + Array(o + 1 - m.length).join(c) + A;
      }, F = { s: B, z: function(A) {
        var o = -A.utcOffset(), c = Math.abs(o), m = Math.floor(c / 60), g = c % 60;
        return (o <= 0 ? "+" : "-") + B(m, 2, "0") + ":" + B(g, 2, "0");
      }, m: function A(o, c) {
        if (o.date() < c.date()) return -A(c, o);
        var m = 12 * (c.year() - o.year()) + (c.month() - o.month()), g = o.clone().add(m, R), y = c - g < 0, p = o.clone().add(m + (y ? -1 : 1), R);
        return +(-(m + (c - g) / (y ? g - p : p - g)) || 0);
      }, a: function(A) {
        return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
      }, p: function(A) {
        return { M: R, y: w, w: D, d: f, D: v, h: d, m: u, s, ms: l, Q: S }[A] || String(A || "").toLowerCase().replace(/s$/, "");
      }, u: function(A) {
        return A === void 0;
      } }, N = "en", G = {};
      G[N] = O;
      var x = "$isDayjsObject", Y = function(A) {
        return A instanceof Z || !(!A || !A[x]);
      }, k = function A(o, c, m) {
        var g;
        if (!o) return N;
        if (typeof o == "string") {
          var y = o.toLowerCase();
          G[y] && (g = y), c && (G[y] = c, g = y);
          var p = o.split("-");
          if (!g && p.length > 1) return A(p[0]);
        } else {
          var E = o.name;
          G[E] = o, g = E;
        }
        return !m && g && (N = g), g || !m && N;
      }, z = function(A, o) {
        if (Y(A)) return A.clone();
        var c = typeof o == "object" ? o : {};
        return c.date = A, c.args = arguments, new Z(c);
      }, P = F;
      P.l = k, P.i = Y, P.w = function(A, o) {
        return z(A, { locale: o.$L, utc: o.$u, x: o.$x, $offset: o.$offset });
      };
      var Z = function() {
        function A(c) {
          this.$L = k(c.locale, null, !0), this.parse(c), this.$x = this.$x || c.x || {}, this[x] = !0;
        }
        var o = A.prototype;
        return o.parse = function(c) {
          this.$d = function(m) {
            var g = m.date, y = m.utc;
            if (g === null) return /* @__PURE__ */ new Date(NaN);
            if (P.u(g)) return /* @__PURE__ */ new Date();
            if (g instanceof Date) return new Date(g);
            if (typeof g == "string" && !/Z$/i.test(g)) {
              var p = g.match(M);
              if (p) {
                var E = p[2] - 1 || 0, I = (p[7] || "0").substring(0, 3);
                return y ? new Date(Date.UTC(p[1], E, p[3] || 1, p[4] || 0, p[5] || 0, p[6] || 0, I)) : new Date(p[1], E, p[3] || 1, p[4] || 0, p[5] || 0, p[6] || 0, I);
              }
            }
            return new Date(g);
          }(c), this.init();
        }, o.init = function() {
          var c = this.$d;
          this.$y = c.getFullYear(), this.$M = c.getMonth(), this.$D = c.getDate(), this.$W = c.getDay(), this.$H = c.getHours(), this.$m = c.getMinutes(), this.$s = c.getSeconds(), this.$ms = c.getMilliseconds();
        }, o.$utils = function() {
          return P;
        }, o.isValid = function() {
          return this.$d.toString() !== h;
        }, o.isSame = function(c, m) {
          var g = z(c);
          return this.startOf(m) <= g && g <= this.endOf(m);
        }, o.isAfter = function(c, m) {
          return z(c) < this.startOf(m);
        }, o.isBefore = function(c, m) {
          return this.endOf(m) < z(c);
        }, o.$g = function(c, m, g) {
          return P.u(c) ? this[m] : this.set(g, c);
        }, o.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, o.valueOf = function() {
          return this.$d.getTime();
        }, o.startOf = function(c, m) {
          var g = this, y = !!P.u(m) || m, p = P.p(c), E = function(ae, W) {
            var Q = P.w(g.$u ? Date.UTC(g.$y, W, ae) : new Date(g.$y, W, ae), g);
            return y ? Q : Q.endOf(f);
          }, I = function(ae, W) {
            return P.w(g.toDate()[ae].apply(g.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), g);
          }, H = this.$W, T = this.$M, $ = this.$D, re = "set" + (this.$u ? "UTC" : "");
          switch (p) {
            case w:
              return y ? E(1, 0) : E(31, 11);
            case R:
              return y ? E(1, T) : E(0, T + 1);
            case D:
              var ee = this.$locale().weekStart || 0, ue = (H < ee ? H + 7 : H) - ee;
              return E(y ? $ - ue : $ + (6 - ue), T);
            case f:
            case v:
              return I(re + "Hours", 0);
            case d:
              return I(re + "Minutes", 1);
            case u:
              return I(re + "Seconds", 2);
            case s:
              return I(re + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, o.endOf = function(c) {
          return this.startOf(c, !1);
        }, o.$set = function(c, m) {
          var g, y = P.p(c), p = "set" + (this.$u ? "UTC" : ""), E = (g = {}, g[f] = p + "Date", g[v] = p + "Date", g[R] = p + "Month", g[w] = p + "FullYear", g[d] = p + "Hours", g[u] = p + "Minutes", g[s] = p + "Seconds", g[l] = p + "Milliseconds", g)[y], I = y === f ? this.$D + (m - this.$W) : m;
          if (y === R || y === w) {
            var H = this.clone().set(v, 1);
            H.$d[E](I), H.init(), this.$d = H.set(v, Math.min(this.$D, H.daysInMonth())).$d;
          } else E && this.$d[E](I);
          return this.init(), this;
        }, o.set = function(c, m) {
          return this.clone().$set(c, m);
        }, o.get = function(c) {
          return this[P.p(c)]();
        }, o.add = function(c, m) {
          var g, y = this;
          c = Number(c);
          var p = P.p(m), E = function(T) {
            var $ = z(y);
            return P.w($.date($.date() + Math.round(T * c)), y);
          };
          if (p === R) return this.set(R, this.$M + c);
          if (p === w) return this.set(w, this.$y + c);
          if (p === f) return E(1);
          if (p === D) return E(7);
          var I = (g = {}, g[u] = i, g[d] = r, g[s] = n, g)[p] || 1, H = this.$d.getTime() + c * I;
          return P.w(H, this);
        }, o.subtract = function(c, m) {
          return this.add(-1 * c, m);
        }, o.format = function(c) {
          var m = this, g = this.$locale();
          if (!this.isValid()) return g.invalidDate || h;
          var y = c || "YYYY-MM-DDTHH:mm:ssZ", p = P.z(this), E = this.$H, I = this.$m, H = this.$M, T = g.weekdays, $ = g.months, re = g.meridiem, ee = function(W, Q, de, ye) {
            return W && (W[Q] || W(m, y)) || de[Q].slice(0, ye);
          }, ue = function(W) {
            return P.s(E % 12 || 12, W, "0");
          }, ae = re || function(W, Q, de) {
            var ye = W < 12 ? "AM" : "PM";
            return de ? ye.toLowerCase() : ye;
          };
          return y.replace(L, function(W, Q) {
            return Q || function(de) {
              switch (de) {
                case "YY":
                  return String(m.$y).slice(-2);
                case "YYYY":
                  return P.s(m.$y, 4, "0");
                case "M":
                  return H + 1;
                case "MM":
                  return P.s(H + 1, 2, "0");
                case "MMM":
                  return ee(g.monthsShort, H, $, 3);
                case "MMMM":
                  return ee($, H);
                case "D":
                  return m.$D;
                case "DD":
                  return P.s(m.$D, 2, "0");
                case "d":
                  return String(m.$W);
                case "dd":
                  return ee(g.weekdaysMin, m.$W, T, 2);
                case "ddd":
                  return ee(g.weekdaysShort, m.$W, T, 3);
                case "dddd":
                  return T[m.$W];
                case "H":
                  return String(E);
                case "HH":
                  return P.s(E, 2, "0");
                case "h":
                  return ue(1);
                case "hh":
                  return ue(2);
                case "a":
                  return ae(E, I, !0);
                case "A":
                  return ae(E, I, !1);
                case "m":
                  return String(I);
                case "mm":
                  return P.s(I, 2, "0");
                case "s":
                  return String(m.$s);
                case "ss":
                  return P.s(m.$s, 2, "0");
                case "SSS":
                  return P.s(m.$ms, 3, "0");
                case "Z":
                  return p;
              }
              return null;
            }(W) || p.replace(":", "");
          });
        }, o.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, o.diff = function(c, m, g) {
          var y, p = this, E = P.p(m), I = z(c), H = (I.utcOffset() - this.utcOffset()) * i, T = this - I, $ = function() {
            return P.m(p, I);
          };
          switch (E) {
            case w:
              y = $() / 12;
              break;
            case R:
              y = $();
              break;
            case S:
              y = $() / 3;
              break;
            case D:
              y = (T - H) / 6048e5;
              break;
            case f:
              y = (T - H) / 864e5;
              break;
            case d:
              y = T / r;
              break;
            case u:
              y = T / i;
              break;
            case s:
              y = T / n;
              break;
            default:
              y = T;
          }
          return g ? y : P.a(y);
        }, o.daysInMonth = function() {
          return this.endOf(R).$D;
        }, o.$locale = function() {
          return G[this.$L];
        }, o.locale = function(c, m) {
          if (!c) return this.$L;
          var g = this.clone(), y = k(c, m, !0);
          return y && (g.$L = y), g;
        }, o.clone = function() {
          return P.w(this.$d, this);
        }, o.toDate = function() {
          return new Date(this.valueOf());
        }, o.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, o.toISOString = function() {
          return this.$d.toISOString();
        }, o.toString = function() {
          return this.$d.toUTCString();
        }, A;
      }(), fe = Z.prototype;
      return z.prototype = fe, [["$ms", l], ["$s", s], ["$m", u], ["$H", d], ["$W", f], ["$M", R], ["$y", w], ["$D", v]].forEach(function(A) {
        fe[A[1]] = function(o) {
          return this.$g(o, A[0], A[1]);
        };
      }), z.extend = function(A, o) {
        return A.$i || (A(o, Z, z), A.$i = !0), z;
      }, z.locale = k, z.isDayjs = Y, z.unix = function(A) {
        return z(1e3 * A);
      }, z.en = G[N], z.Ls = G, z.p = {}, z;
    });
  }(Se)), Se.exports;
}
var rr = nn();
const X = /* @__PURE__ */ j(rr);
var Ae = { exports: {} }, or = Ae.exports, Ca;
function sr() {
  return Ca || (Ca = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(or, function() {
      return function(n, i) {
        var r = i.prototype, l = r.format;
        r.format = function(s) {
          var u = this, d = this.$locale();
          if (!this.isValid()) return l.bind(this)(s);
          var f = this.$utils(), D = (s || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(R) {
            switch (R) {
              case "Q":
                return Math.ceil((u.$M + 1) / 3);
              case "Do":
                return d.ordinal(u.$D);
              case "gggg":
                return u.weekYear();
              case "GGGG":
                return u.isoWeekYear();
              case "wo":
                return d.ordinal(u.week(), "W");
              case "w":
              case "ww":
                return f.s(u.week(), R === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return f.s(u.isoWeek(), R === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return f.s(String(u.$H === 0 ? 24 : u.$H), R === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(u.$d.getTime() / 1e3);
              case "x":
                return u.$d.getTime();
              case "z":
                return "[" + u.offsetName() + "]";
              case "zzz":
                return "[" + u.offsetName("long") + "]";
              default:
                return R;
            }
          });
          return l.bind(this)(D);
        };
      };
    });
  }(Ae)), Ae.exports;
}
var lr = sr();
const cr = /* @__PURE__ */ j(lr);
var we = { exports: {} }, ur = we.exports, Sa;
function dr() {
  return Sa || (Sa = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(ur, function() {
      return function(n, i, r) {
        i.prototype.isBetween = function(l, s, u, d) {
          var f = r(l), D = r(s), R = (d = d || "()")[0] === "(", S = d[1] === ")";
          return (R ? this.isAfter(f, u) : !this.isBefore(f, u)) && (S ? this.isBefore(D, u) : !this.isAfter(D, u)) || (R ? this.isBefore(f, u) : !this.isAfter(f, u)) && (S ? this.isAfter(D, u) : !this.isBefore(D, u));
        };
      };
    });
  }(we)), we.exports;
}
var gr = dr();
const mr = /* @__PURE__ */ j(gr);
var ve = { exports: {} }, hr = ve.exports, Aa;
function pr() {
  return Aa || (Aa = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(hr, function() {
      return function(n, i) {
        i.prototype.isSameOrAfter = function(r, l) {
          return this.isSame(r, l) || this.isAfter(r, l);
        };
      };
    });
  }(ve)), ve.exports;
}
var fr = pr();
const yr = /* @__PURE__ */ j(fr);
var Re = { exports: {} }, br = Re.exports, wa;
function Dr() {
  return wa || (wa = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(br, function() {
      return function(n, i) {
        i.prototype.isSameOrBefore = function(r, l) {
          return this.isSame(r, l) || this.isBefore(r, l);
        };
      };
    });
  }(Re)), Re.exports;
}
var Cr = Dr();
const Sr = /* @__PURE__ */ j(Cr);
var Me = { exports: {} }, Ar = Me.exports, va;
function wr() {
  return va || (va = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(Ar, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(i, r, l) {
        var s = r.prototype, u = s.format;
        l.en.formats = n, s.format = function(d) {
          d === void 0 && (d = "YYYY-MM-DDTHH:mm:ssZ");
          var f = this.$locale().formats, D = function(R, S) {
            return R.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(w, v, h) {
              var M = h && h.toUpperCase();
              return v || S[h] || n[h] || S[M].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, O, B) {
                return O || B.slice(1);
              });
            });
          }(d, f === void 0 ? {} : f);
          return u.call(this, D);
        };
      };
    });
  }(Me)), Me.exports;
}
var vr = wr();
const Rr = /* @__PURE__ */ j(vr);
var Pe = { exports: {} }, Mr = Pe.exports, Ra;
function Pr() {
  return Ra || (Ra = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(Mr, function() {
      return function(n, i, r) {
        var l = function(s, u) {
          if (!u || !u.length || u.length === 1 && !u[0] || u.length === 1 && Array.isArray(u[0]) && !u[0].length) return null;
          var d;
          u.length === 1 && u[0].length > 0 && (u = u[0]), d = (u = u.filter(function(D) {
            return D;
          }))[0];
          for (var f = 1; f < u.length; f += 1) u[f].isValid() && !u[f][s](d) || (d = u[f]);
          return d;
        };
        r.max = function() {
          var s = [].slice.call(arguments, 0);
          return l("isAfter", s);
        }, r.min = function() {
          var s = [].slice.call(arguments, 0);
          return l("isBefore", s);
        };
      };
    });
  }(Pe)), Pe.exports;
}
var Tr = Pr();
const Nr = /* @__PURE__ */ j(Tr);
var Te = { exports: {} }, Er = Te.exports, Ma;
function Br() {
  return Ma || (Ma = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(Er, function() {
      return function(n, i, r) {
        n = n || {};
        var l = i.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function u(f, D, R, S) {
          return l.fromToBase(f, D, R, S);
        }
        r.en.relativeTime = s, l.fromToBase = function(f, D, R, S, w) {
          for (var v, h, M, L = R.$locale().relativeTime || s, O = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], B = O.length, F = 0; F < B; F += 1) {
            var N = O[F];
            N.d && (v = S ? r(f).diff(R, N.d, !0) : R.diff(f, N.d, !0));
            var G = (n.rounding || Math.round)(Math.abs(v));
            if (M = v > 0, G <= N.r || !N.r) {
              G <= 1 && F > 0 && (N = O[F - 1]);
              var x = L[N.l];
              w && (G = w("" + G)), h = typeof x == "string" ? x.replace("%d", G) : x(G, D, N.l, M);
              break;
            }
          }
          if (D) return h;
          var Y = M ? L.future : L.past;
          return typeof Y == "function" ? Y(h) : Y.replace("%s", h);
        }, l.to = function(f, D) {
          return u(f, D, this, !0);
        }, l.from = function(f, D) {
          return u(f, D, this);
        };
        var d = function(f) {
          return f.$u ? r.utc() : r();
        };
        l.toNow = function(f) {
          return this.to(d(this), f);
        }, l.fromNow = function(f) {
          return this.from(d(this), f);
        };
      };
    });
  }(Te)), Te.exports;
}
var zr = Br();
const Lr = /* @__PURE__ */ j(zr);
var Ne = { exports: {} }, Or = Ne.exports, Pa;
function Gr() {
  return Pa || (Pa = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(Or, function() {
      var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, i = {};
      return function(r, l, s) {
        var u, d = function(S, w, v) {
          v === void 0 && (v = {});
          var h = new Date(S), M = function(L, O) {
            O === void 0 && (O = {});
            var B = O.timeZoneName || "short", F = L + "|" + B, N = i[F];
            return N || (N = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: L, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: B }), i[F] = N), N;
          }(w, v);
          return M.formatToParts(h);
        }, f = function(S, w) {
          for (var v = d(S, w), h = [], M = 0; M < v.length; M += 1) {
            var L = v[M], O = L.type, B = L.value, F = n[O];
            F >= 0 && (h[F] = parseInt(B, 10));
          }
          var N = h[3], G = N === 24 ? 0 : N, x = h[0] + "-" + h[1] + "-" + h[2] + " " + G + ":" + h[4] + ":" + h[5] + ":000", Y = +S;
          return (s.utc(x).valueOf() - (Y -= Y % 1e3)) / 6e4;
        }, D = l.prototype;
        D.tz = function(S, w) {
          S === void 0 && (S = u);
          var v, h = this.utcOffset(), M = this.toDate(), L = M.toLocaleString("en-US", { timeZone: S }), O = Math.round((M - new Date(L)) / 1e3 / 60), B = 15 * -Math.round(M.getTimezoneOffset() / 15) - O;
          if (!Number(B)) v = this.utcOffset(0, w);
          else if (v = s(L, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(B, !0), w) {
            var F = v.utcOffset();
            v = v.add(h - F, "minute");
          }
          return v.$x.$timezone = S, v;
        }, D.offsetName = function(S) {
          var w = this.$x.$timezone || s.tz.guess(), v = d(this.valueOf(), w, { timeZoneName: S }).find(function(h) {
            return h.type.toLowerCase() === "timezonename";
          });
          return v && v.value;
        };
        var R = D.startOf;
        D.startOf = function(S, w) {
          if (!this.$x || !this.$x.$timezone) return R.call(this, S, w);
          var v = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return R.call(v, S, w).tz(this.$x.$timezone, !0);
        }, s.tz = function(S, w, v) {
          var h = v && w, M = v || w || u, L = f(+s(), M);
          if (typeof S != "string") return s(S).tz(M);
          var O = function(G, x, Y) {
            var k = G - 60 * x * 1e3, z = f(k, Y);
            if (x === z) return [k, x];
            var P = f(k -= 60 * (z - x) * 1e3, Y);
            return z === P ? [k, z] : [G - 60 * Math.min(z, P) * 1e3, Math.max(z, P)];
          }(s.utc(S, h).valueOf(), L, M), B = O[0], F = O[1], N = s(B).utcOffset(F);
          return N.$x.$timezone = M, N;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(S) {
          u = S;
        };
      };
    });
  }(Ne)), Ne.exports;
}
var Ir = Gr();
const Kr = /* @__PURE__ */ j(Ir);
var Ee = { exports: {} }, _r = Ee.exports, Ta;
function Ur() {
  return Ta || (Ta = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(_r, function() {
      var n = "minute", i = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
      return function(l, s, u) {
        var d = s.prototype;
        u.utc = function(h) {
          var M = { date: h, utc: !0, args: arguments };
          return new s(M);
        }, d.utc = function(h) {
          var M = u(this.toDate(), { locale: this.$L, utc: !0 });
          return h ? M.add(this.utcOffset(), n) : M;
        }, d.local = function() {
          return u(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var f = d.parse;
        d.parse = function(h) {
          h.utc && (this.$u = !0), this.$utils().u(h.$offset) || (this.$offset = h.$offset), f.call(this, h);
        };
        var D = d.init;
        d.init = function() {
          if (this.$u) {
            var h = this.$d;
            this.$y = h.getUTCFullYear(), this.$M = h.getUTCMonth(), this.$D = h.getUTCDate(), this.$W = h.getUTCDay(), this.$H = h.getUTCHours(), this.$m = h.getUTCMinutes(), this.$s = h.getUTCSeconds(), this.$ms = h.getUTCMilliseconds();
          } else D.call(this);
        };
        var R = d.utcOffset;
        d.utcOffset = function(h, M) {
          var L = this.$utils().u;
          if (L(h)) return this.$u ? 0 : L(this.$offset) ? R.call(this) : this.$offset;
          if (typeof h == "string" && (h = function(N) {
            N === void 0 && (N = "");
            var G = N.match(i);
            if (!G) return null;
            var x = ("" + G[0]).match(r) || ["-", 0, 0], Y = x[0], k = 60 * +x[1] + +x[2];
            return k === 0 ? 0 : Y === "+" ? k : -k;
          }(h), h === null)) return this;
          var O = Math.abs(h) <= 16 ? 60 * h : h, B = this;
          if (M) return B.$offset = O, B.$u = h === 0, B;
          if (h !== 0) {
            var F = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (B = this.local().add(O + F, n)).$offset = O, B.$x.$localOffset = F;
          } else B = this.utc();
          return B;
        };
        var S = d.format;
        d.format = function(h) {
          var M = h || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return S.call(this, M);
        }, d.valueOf = function() {
          var h = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * h;
        }, d.isUTC = function() {
          return !!this.$u;
        }, d.toISOString = function() {
          return this.toDate().toISOString();
        }, d.toString = function() {
          return this.toDate().toUTCString();
        };
        var w = d.toDate;
        d.toDate = function(h) {
          return h === "s" && this.$offset ? u(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : w.call(this);
        };
        var v = d.diff;
        d.diff = function(h, M, L) {
          if (h && this.$u === h.$u) return v.call(this, h, M, L);
          var O = this.local(), B = u(h).local();
          return v.call(O, B, M, L);
        };
      };
    });
  }(Ee)), Ee.exports;
}
var Fr = Ur();
const kr = /* @__PURE__ */ j(Fr);
var Be = { exports: {} }, Hr = Be.exports, Na;
function $r() {
  return Na || (Na = 1, function(e, a) {
    (function(n, i) {
      e.exports = i(nn());
    })(Hr, function(n) {
      function i(s) {
        return s && typeof s == "object" && "default" in s ? s : { default: s };
      }
      var r = i(n), l = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(s) {
        return "" + s + (s === 1 ? "er" : "");
      } };
      return r.default.locale(l, null, !0), l;
    });
  }(Be)), Be.exports;
}
$r();
var ze = { exports: {} }, xr = ze.exports, Ea;
function Yr() {
  return Ea || (Ea = 1, function(e, a) {
    (function(n, i) {
      e.exports = i();
    })(xr, function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var i = ["th", "st", "nd", "rd"], r = n % 100;
        return "[" + n + (i[(r - 20) % 10] || i[r] || i[0]) + "]";
      } };
    });
  }(ze)), ze.exports;
}
Yr();
X.extend(cr);
X.extend(mr);
X.extend(yr);
X.extend(Sr);
X.extend(Rr);
X.extend(Nr);
X.extend(Lr);
X.extend(Kr);
X.extend(kr);
const V = [];
for (let e = 0; e < 256; ++e)
  V.push((e + 256).toString(16).slice(1));
function Vr(e, a = 0) {
  return (V[e[a + 0]] + V[e[a + 1]] + V[e[a + 2]] + V[e[a + 3]] + "-" + V[e[a + 4]] + V[e[a + 5]] + "-" + V[e[a + 6]] + V[e[a + 7]] + "-" + V[e[a + 8]] + V[e[a + 9]] + "-" + V[e[a + 10]] + V[e[a + 11]] + V[e[a + 12]] + V[e[a + 13]] + V[e[a + 14]] + V[e[a + 15]]).toLowerCase();
}
let $e;
const Zr = new Uint8Array(16);
function Wr() {
  if (!$e) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    $e = crypto.getRandomValues.bind(crypto);
  }
  return $e(Zr);
}
const jr = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Ba = { randomUUID: jr };
function Jr(e, a, n) {
  if (Ba.randomUUID && !e)
    return Ba.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Wr();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Vr(i);
}
const qr = 1500;
class oe {
  static instance = null;
  defaultOptions = {
    callCount: 1,
    interval: qr,
    maxCallCount: 20,
    minCallCount: 1
  };
  pollings = {};
  events = {
    complete: () => {
    },
    data: () => {
    },
    error: () => {
    }
  };
  static getInstance() {
    return oe.instance || (oe.instance = new oe()), oe.instance;
  }
  poll(a, n) {
    const i = this.buildPollerOptions(n);
    return this.storeCurrentPolling(i), this.isActivePoller(i) && a().then((r) => this.onRequest(r, a, i)).catch((r) => {
      this.dispatch("error", r);
    }), this;
  }
  on(a, n) {
    this.events[a] = n;
  }
  stop(a) {
    a && this.pollings[a] && delete this.pollings[a];
  }
  dispatch(a, n) {
    this.events[a](n);
  }
  async onRequest(a, n, i) {
    const r = b(a ?? {}, C.Camel);
    this.isActivePoller(i) && (this.isInProgress(r) && i.callCount && i.maxCallCount && i.callCount < i.maxCallCount || !this.isInProgress(r) && i.callCount && i.minCallCount && i.callCount < i.minCallCount ? (this.isInProgress(r) || (r.meta = r.meta || {}, r.meta.status = "IN_PROGRESS"), i.callCount += 1, this.dispatch("data", r), i.interval && await this.pause(i), this.poll(n, i)) : this.isInProgress(r) ? (r.meta = r.meta || {}, r.meta.status = "COMPLETE", this.onComplete(r, i)) : this.onComplete(r, i));
  }
  onComplete(a, n) {
    this.dispatch("data", a), this.dispatch("complete", a), this.removeCurrentPolling(n);
  }
  isInProgress(a) {
    return (a?.meta?.status ?? "") !== "COMPLETE";
  }
  buildPollerOptions(a) {
    const n = Object.entries(a).reduce(
      (i, [r, l]) => {
        if (l !== void 0) {
          const s = r;
          i[s] = l;
        }
        return i;
      },
      {}
    );
    return {
      ...this.defaultOptions,
      ...n
    };
  }
  storeCurrentPolling(a) {
    a.type && !a.uuid && (a.uuid = Jr(), this.pollings[a.type] = a.uuid);
  }
  isActivePoller(a) {
    return a.type ? !!this.pollings[a.type] && this.pollings[a.type] === a.uuid : !0;
  }
  pause(a) {
    return new Promise((n) => {
      setTimeout(n, a.interval);
    });
  }
  removeCurrentPolling(a) {
    a.type && this.pollings[a.type] && delete this.pollings[a.type];
  }
}
function tn(e, a, n) {
  const i = oe.getInstance();
  return i.poll(e, a), n && typeof n == "function" ? (i.on("data", (r) => {
    r instanceof Error ? n(r, void 0, i) : n(null, r, i);
  }), i.on("error", (r) => {
    r instanceof Error ? n(r) : n(null, r);
  }), i) : new Promise((r, l) => {
    i.on("error", l), i.on("complete", (s) => {
      s instanceof Error ? l(s) : r(s);
    });
  });
}
class Xr extends J {
  /**
   * In order to be able to create and confirm a booking against a specific **Hotel Room Offer** package, you need to make a booking policy call.  Retrieving a booking policy returns additional information about the booking being made and includes details like cancellation policies.  This API call is equivalent to an availability check and it is important not to let long periods between retrieval of this policy and the booking confirmation call itself as this will often reduce the likelihood of the **Hotel Room Offer** being successfully booked.  The **booking_policy_id** returned is meant to be used to carry out a pre-book call via **[Pre Book endpoint](/v1/documentation#operation/postV1Bookings)** on the next **Booking Flow** step.  ⚠️ This call may take from 1 second up to 15 seconds to return as we may request various suppliers to fulfill this request.
   * Create Booking Policies
   */
  async createRaw(a, n) {
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/booking_policies",
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.bookingPoliciesCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * In order to be able to create and confirm a booking against a specific **Hotel Room Offer** package, you need to make a booking policy call.  Retrieving a booking policy returns additional information about the booking being made and includes details like cancellation policies.  This API call is equivalent to an availability check and it is important not to let long periods between retrieval of this policy and the booking confirmation call itself as this will often reduce the likelihood of the **Hotel Room Offer** being successfully booked.  The **booking_policy_id** returned is meant to be used to carry out a pre-book call via **[Pre Book endpoint](/v1/documentation#operation/postV1Bookings)** on the next **Booking Flow** step.  ⚠️ This call may take from 1 second up to 15 seconds to return as we may request various suppliers to fulfill this request.
   * Create Booking Policies
   */
  async create(a = {}, n) {
    return this.createRaw(a, n);
  }
}
class Qr extends J {
  /**
   * Cancel a confirmed Booking. A booking can only be cancelled if it\'s in one of the following status: **bkg-cf**, **bkg-pc**.
   * Cancel a Booking
   */
  async deleteRaw(a, n) {
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling deleteV1BookingsToken.");
    const i = {}, r = {}, l = await this.request({
      path: "/v1/bookings/{token}".replace("{token}", encodeURIComponent(String(a.token))),
      method: "DELETE",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Cancel a confirmed Booking. A booking can only be cancelled if it\'s in one of the following status: **bkg-cf**, **bkg-pc**.
   * Cancel a Booking
   */
  async delete(a, n) {
    return this.deleteRaw(a, n);
  }
  /**
   * Returns a list of detailed bookings made on behalf of a specific API Key credential.
   * List Bookings
   */
  async listRaw(a, n) {
    const i = {};
    a.endingBefore !== void 0 && (i.ending_before = a.endingBefore), a.filterByCheckInDate !== void 0 && (i.filter_by_check_in_date = a.filterByCheckInDate), a.filterByLastStatusUpdatedAt !== void 0 && (i.filter_by_last_status_updated_at = a.filterByLastStatusUpdatedAt), a.filterByStatus !== void 0 && (i.filter_by_status = a.filterByStatus), a.limit !== void 0 && (i.limit = a.limit), a.sortBy !== void 0 && (i.sort_by = a.sortBy), a.sortByOrder !== void 0 && (i.sort_by_order = a.sortByOrder), a.startingAfter !== void 0 && (i.starting_after = a.startingAfter);
    const r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings",
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Returns a list of detailed bookings made on behalf of a specific API Key credential.
   * List Bookings
   */
  async list(a = {}, n) {
    return this.listRaw(a, n);
  }
  /**
   * Retrieve the status and information of a booking.
   * Retrieve a Booking
   */
  async retrieveRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1BookingsId.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}".replace("{id}", encodeURIComponent(String(a.id))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Retrieve the status and information of a booking.
   * Retrieve a Booking
   */
  async retrieve(a, n) {
    return this.retrieveRaw(a, n);
  }
  /**
   * Retrieve the status and information of a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Retrieve a Booking (PUBLIC)
   */
  async retrievePublicRaw(a, n) {
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling getV1BookingsTokenPublic.");
    const i = {}, r = {}, l = await this.request({
      path: "/v1/bookings/{token}/public".replace("{token}", encodeURIComponent(String(a.token))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Retrieve the status and information of a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Retrieve a Booking (PUBLIC)
   */
  async retrievePublic(a, n) {
    return this.retrievePublicRaw(a, n);
  }
  /**
   * Creates an unconfirmed booking
   * Create an unconfirmed Booking
   */
  async createRaw(a, n) {
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings",
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.bookingCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Creates an unconfirmed booking
   * Create an unconfirmed Booking
   */
  async create(a = {}, n) {
    return this.createRaw(a, n);
  }
  /**
   * Confirm booking from Coupon payment method
   * Confirm booking from Coupon payment method
   */
  async couponChargeRaw(a, n) {
    if (a.couponId === null || a.couponId === void 0)
      throw new U("couponId", "Required parameter requestParameters.couponId was null or undefined when calling postV1BookingsIdCouponsCouponIdCharge.");
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdCouponsCouponIdCharge.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}/coupons/{coupon_id}/charge".replace("{coupon_id}", encodeURIComponent(String(a.couponId))).replace("{id}", encodeURIComponent(String(a.id))),
      method: "POST",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Confirm booking from Coupon payment method
   * Confirm booking from Coupon payment method
   */
  async couponCharge(a, n) {
    return this.couponChargeRaw(a, n);
  }
  /**
   * Pay later and retrieve the status and information of a booking.
   * Pay later a Booking
   */
  async paylaterRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdPayLater.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}/pay-later".replace("{id}", encodeURIComponent(String(a.id))),
      method: "POST",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Pay later and retrieve the status and information of a booking.
   * Pay later a Booking
   */
  async paylater(a, n) {
    return this.paylaterRaw(a, n);
  }
  /**
   * Confirm later paid and retrieve the status and information of a booking.
   * Confirm a later paid Booking
   */
  async confirmpaylaterRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdPayLaterConfirm.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}/pay-later/confirm".replace("{id}", encodeURIComponent(String(a.id))),
      method: "POST",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Confirm later paid and retrieve the status and information of a booking.
   * Confirm a later paid Booking
   */
  async confirmpaylater(a, n) {
    return this.confirmpaylaterRaw(a, n);
  }
  /**
   * Trigger the actual booking confirmation process.  💡 This endpoint is only available for Bookings in the **bkg-created** status.  ⚠️ The booking confirmation is an asynchronous process. The booking won\'t transition immediatly to **bkg-cf** status. Rather, the endpoint will return a booking in **bkg-ip** and you\'ll be required to check booking status calling **[Get Booking endpoint](/v1/documentation#operation/getV1BookingsId)**, ideally with a polling mechanism, and perform further action(s), whether you need to let your customer know about their booking or you just need to update some data on your system, when booking status transitions to **bkg-cf** (confirmed) or  **bkg-af** (fail).  ⚠️ Once you have called this endpoint, we immediatly send your confirmation request to our supplier(s) and they may confirm it immediatly, so you\'ll be liable for up to the total booking tax included price amount if you need to cancel it at a later time (refer to the booking\'s cancellation policies to get the actual current penalty percentage applied in case of cancellation).
   * Confirm an ongoing Booking
   */
  async confirmRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdconfirm.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}/confirm".replace("{id}", encodeURIComponent(String(a.id))),
      method: "POST",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Trigger the actual booking confirmation process.  💡 This endpoint is only available for Bookings in the **bkg-created** status.  ⚠️ The booking confirmation is an asynchronous process. The booking won\'t transition immediatly to **bkg-cf** status. Rather, the endpoint will return a booking in **bkg-ip** and you\'ll be required to check booking status calling **[Get Booking endpoint](/v1/documentation#operation/getV1BookingsId)**, ideally with a polling mechanism, and perform further action(s), whether you need to let your customer know about their booking or you just need to update some data on your system, when booking status transitions to **bkg-cf** (confirmed) or  **bkg-af** (fail).  ⚠️ Once you have called this endpoint, we immediatly send your confirmation request to our supplier(s) and they may confirm it immediatly, so you\'ll be liable for up to the total booking tax included price amount if you need to cancel it at a later time (refer to the booking\'s cancellation policies to get the actual current penalty percentage applied in case of cancellation).
   * Confirm an ongoing Booking
   */
  async confirm(a, n) {
    return this.confirmRaw(a, n);
  }
  /**
   * Updates an ongoing Booking payment methods
   * Updates an ongoing Booking payment methods
   */
  async updatePaymentMethodsRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling putV1BookingsIdPaymentMethods.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/bookings/{id}/payment_methods".replace("{id}", encodeURIComponent(String(a.id))),
      method: "PUT",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.paymentMethodUpdatePayloadApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Updates an ongoing Booking payment methods
   * Updates an ongoing Booking payment methods
   */
  async updatePaymentMethods(a, n) {
    return this.updatePaymentMethodsRaw(a, n);
  }
}
const $o = {
  CheckInDate: "check_in_date",
  CreatedAt: "created_at",
  LastStatusUpdatedAt: "last_status_updated_at"
}, xo = {
  Asc: "asc",
  Desc: "desc"
};
class eo extends J {
  /**
   * Returns a list of images for an Hotel Id with their content localize into the requested **lang**.
   * Retrieve Images of an Hotel
   */
  async retrieveRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelsIdImages.");
    const i = {};
    a.lang !== void 0 && (i.lang = a.lang);
    const r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotels/{id}/images".replace("{id}", encodeURIComponent(String(a.id))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Returns a list of images for an Hotel Id with their content localize into the requested **lang**.
   * Retrieve Images of an Hotel
   */
  async retrieve(a, n) {
    return this.retrieveRaw(a, n);
  }
}
const Yo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class ao extends J {
  /**
   * Returns a single Hotel Offer Request by id
   * Retrieve a Single Hotel Offer Request
   */
  async retrieveRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelOfferRequestsId.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_offer_requests/{id}".replace("{id}", encodeURIComponent(String(a.id))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Returns a single Hotel Offer Request by id
   * Retrieve a Single Hotel Offer Request
   */
  async retrieve(a, n) {
    return this.retrieveRaw(a, n);
  }
  /**
   * Create an **Hotel Offer Request**. An **Hotel Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and obviously the location around which they need their accommodation to be (latitude/longitude pair).
   * Create an Hotel Offer Request
   */
  async createRaw(a, n) {
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_offer_requests",
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.hotelOfferRequestCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Create an **Hotel Offer Request**. An **Hotel Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and obviously the location around which they need their accommodation to be (latitude/longitude pair).
   * Create an Hotel Offer Request
   */
  async create(a = {}, n) {
    return this.createRaw(a, n);
  }
}
class no extends J {
  /**
   * You\'ll then make a call to the **Hotel Offers** endpoint to retrieve a list of **Hotel Offers** associated with your **Hotel Offer Request**. We\'ll send your search to a pool of hotels matching the search parameters you provided previously. The **Hotel Offers** endpoint will return hotels with available rates as **Hotel Room Offers** objects for each hotel in the list. For a detailed overview of the **Hotel Room Offer** object, see **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint.  ⚠️ **IMPORTANT**: The **Hotel Room Offers** included in each **Hotel Offer** returned by the **[Retrieve Hotel Offers](/v1/documentation#operation/getV1Hotel_offers)** endpoint might be **<span style=\"color:red\">cached data</span>**. In that case, the returned prices/availability may be slightly different from actual live inventory. In order to retrieve accurate and live **Hotel Room Offers** for a specific hotel you need to make a call to the **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint. We do not recommend to systematically call **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** for each hotel offer retrieved as it may trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Offers** around a location, then, once your customer shows interest in a specific **Hotel Offer**, you check **Hotel Room Offers** on that specific hotel.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Offers
   */
  async listRaw(a, n) {
    if (a.currency === null || a.currency === void 0)
      throw new U("currency", "Required parameter requestParameters.currency was null or undefined when calling getV1HotelOffers.");
    if (a.hotelOfferRequestId === null || a.hotelOfferRequestId === void 0)
      throw new U("hotelOfferRequestId", "Required parameter requestParameters.hotelOfferRequestId was null or undefined when calling getV1HotelOffers.");
    const i = {};
    a.currency !== void 0 && (i.currency = a.currency), a.endingBefore !== void 0 && (i.ending_before = a.endingBefore), a.filterByPrice !== void 0 && (i.filter_by_price = a.filterByPrice), a.filterByReviewRating !== void 0 && (i.filter_by_review_rating = a.filterByReviewRating), a.filterByStar !== void 0 && (i.filter_by_star = a.filterByStar), a.hotelOfferRequestId !== void 0 && (i.hotel_offer_request_id = a.hotelOfferRequestId), a.hotelRoomOffersLimit !== void 0 && (i.hotel_room_offers_limit = a.hotelRoomOffersLimit), a.includeHotelContentDetails !== void 0 && (i.include_hotel_content_details = a.includeHotelContentDetails), a.lang !== void 0 && (i.lang = a.lang), a.limit !== void 0 && (i.limit = a.limit), a.onlyRecommendedHotelOffers !== void 0 && (i.only_recommended_hotel_offers = a.onlyRecommendedHotelOffers), a.priceHistogramStepCount !== void 0 && (i.price_histogram_step_count = a.priceHistogramStepCount), a.sortBy !== void 0 && (i.sort_by = a.sortBy), a.sortByOrder !== void 0 && (i.sort_by_order = a.sortByOrder), a.startingAfter !== void 0 && (i.starting_after = a.startingAfter);
    const r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_offers",
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * You\'ll then make a call to the **Hotel Offers** endpoint to retrieve a list of **Hotel Offers** associated with your **Hotel Offer Request**. We\'ll send your search to a pool of hotels matching the search parameters you provided previously. The **Hotel Offers** endpoint will return hotels with available rates as **Hotel Room Offers** objects for each hotel in the list. For a detailed overview of the **Hotel Room Offer** object, see **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint.  ⚠️ **IMPORTANT**: The **Hotel Room Offers** included in each **Hotel Offer** returned by the **[Retrieve Hotel Offers](/v1/documentation#operation/getV1Hotel_offers)** endpoint might be **<span style=\"color:red\">cached data</span>**. In that case, the returned prices/availability may be slightly different from actual live inventory. In order to retrieve accurate and live **Hotel Room Offers** for a specific hotel you need to make a call to the **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint. We do not recommend to systematically call **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** for each hotel offer retrieved as it may trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Offers** around a location, then, once your customer shows interest in a specific **Hotel Offer**, you check **Hotel Room Offers** on that specific hotel.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Offers
   */
  async list(a, n, i) {
    return await tn(
      () => this.listRaw(a, i),
      { type: na.HOTEL_SEARCH_POLLING, minCallCount: i?.minCallCount, maxCallCount: i?.maxCallCount },
      n
    );
  }
}
const Vo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, Zo = {
  Distance: "distance",
  Price: "price",
  Rating: "rating",
  ReviewRating: "review_rating",
  TopPicks: "top_picks"
}, Wo = {
  Asc: "asc",
  Desc: "desc"
};
class io extends J {
  /**
   * Returns a single Hotel Room Offer Request by id
   * Retrieve a Single Hotel Room Offer Request
   */
  async retrieveRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelRoomOfferRequestsId.");
    const i = {}, r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_room_offer_requests/{id}".replace("{id}", encodeURIComponent(String(a.id))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Returns a single Hotel Room Offer Request by id
   * Retrieve a Single Hotel Room Offer Request
   */
  async retrieve(a, n) {
    return this.retrieveRaw(a, n);
  }
  /**
   * To check available rates, or **Hotel Room Offers**, at a specific hotel, you first need to create an **Hotel Room Offer Request**. An **Hotel Room Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and the id of the hotel you want to check available rates at.
   * Create an Hotel Room Offer Request
   */
  async createRaw(a, n) {
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_room_offer_requests",
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.hotelRoomOfferRequestCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * To check available rates, or **Hotel Room Offers**, at a specific hotel, you first need to create an **Hotel Room Offer Request**. An **Hotel Room Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and the id of the hotel you want to check available rates at.
   * Create an Hotel Room Offer Request
   */
  async create(a = {}, n) {
    return this.createRaw(a, n);
  }
}
class to extends J {
  /**
   * You\'ll make a call to the **Hotel Room Offers** endpoint in order to get a list of **Hotel Room Offers** resulting from your **Hotel Room Offer Request** parameters. We\'ll send your rate check request to the specific hotel matching the hotel ID you provided previously and the **Hotel Room Offers** endpoint will return the available rates at this specific hotel. An **Hotel Room Offer** describes hotel rooms: prices, remaining count available (when applicable), details about the room itself (e.g., beds, etc) and other information you\'ll find below.   ⚠️ **Cancellation Policies** attached to each **Hotel Room Offer** returned by this endpoint will most likely be **<span style=\"color:red\">cached data</span>** and should not be considered as accurate, although in most case they will reflect the actual/live ones.  In order to retrieve accurate and live **Cancellation Policies** for a specific **Hotel Room Offer** you need to make a call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)**. However, we do not recommend to systematically call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** for each **Hotel Room Offer** retrieved as it will most likely trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Room Offers**, then, once your customer shows interest in a specific **Hotel Room Offer**, you make the call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** on behalf of your customer.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Room Offers
   */
  async listRaw(a, n) {
    if (a.currency === null || a.currency === void 0)
      throw new U("currency", "Required parameter requestParameters.currency was null or undefined when calling getV1HotelRoomOffers.");
    if (a.hotelRoomOfferRequestId === null || a.hotelRoomOfferRequestId === void 0)
      throw new U("hotelRoomOfferRequestId", "Required parameter requestParameters.hotelRoomOfferRequestId was null or undefined when calling getV1HotelRoomOffers.");
    const i = {};
    a.currency !== void 0 && (i.currency = a.currency), a.hotelRoomOfferRequestId !== void 0 && (i.hotel_room_offer_request_id = a.hotelRoomOfferRequestId), a.lang !== void 0 && (i.lang = a.lang), a.limit !== void 0 && (i.limit = a.limit);
    const r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_room_offers",
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * You\'ll make a call to the **Hotel Room Offers** endpoint in order to get a list of **Hotel Room Offers** resulting from your **Hotel Room Offer Request** parameters. We\'ll send your rate check request to the specific hotel matching the hotel ID you provided previously and the **Hotel Room Offers** endpoint will return the available rates at this specific hotel. An **Hotel Room Offer** describes hotel rooms: prices, remaining count available (when applicable), details about the room itself (e.g., beds, etc) and other information you\'ll find below.   ⚠️ **Cancellation Policies** attached to each **Hotel Room Offer** returned by this endpoint will most likely be **<span style=\"color:red\">cached data</span>** and should not be considered as accurate, although in most case they will reflect the actual/live ones.  In order to retrieve accurate and live **Cancellation Policies** for a specific **Hotel Room Offer** you need to make a call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)**. However, we do not recommend to systematically call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** for each **Hotel Room Offer** retrieved as it will most likely trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Room Offers**, then, once your customer shows interest in a specific **Hotel Room Offer**, you make the call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** on behalf of your customer.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Room Offers
   */
  async list(a, n, i) {
    return await tn(
      () => this.listRaw(a, i),
      { type: na.HOTEL_ROOM_OFFERS, minCallCount: i?.minCallCount, maxCallCount: i?.maxCallCount },
      n
    );
  }
  /**
   * This enpoint creates a new **Hotel Room Offer** based on previously fetched **Hotel Room Offer(s)** and may be used for the following purposes:  - Check a specific **Hotel Room Offer** live availability  - Create a new **Hotel Room Offer** with **type = \"PACKAGE\"** based on multiple **Hotel Room Offers** where **type = \"HOTEL_ROOM\"** and be able to call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** with it  - Update an existing **Hotel Room Offer** with **type = \"PACKAGE\"** in order to include extra option(s) like breakfast in the returned price.   We strongly recommend to make use of this endpoint if you want to offer some kind of Shopping Cart experience to your customer when **[Retrieve HotelRoom Offers endpoint](/v1/documentation#operation/getV1Hotel_room_offers)** returns multiple **Hotel Room Offers** with **type = \"HOTEL_ROOM\"**.
   * Create Hotel Room Offer
   */
  async createRaw(a, n) {
    const i = {}, r = {};
    r["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotel_room_offers",
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.hotelRoomOffersCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * This enpoint creates a new **Hotel Room Offer** based on previously fetched **Hotel Room Offer(s)** and may be used for the following purposes:  - Check a specific **Hotel Room Offer** live availability  - Create a new **Hotel Room Offer** with **type = \"PACKAGE\"** based on multiple **Hotel Room Offers** where **type = \"HOTEL_ROOM\"** and be able to call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** with it  - Update an existing **Hotel Room Offer** with **type = \"PACKAGE\"** in order to include extra option(s) like breakfast in the returned price.   We strongly recommend to make use of this endpoint if you want to offer some kind of Shopping Cart experience to your customer when **[Retrieve HotelRoom Offers endpoint](/v1/documentation#operation/getV1Hotel_room_offers)** returns multiple **Hotel Room Offers** with **type = \"HOTEL_ROOM\"**.
   * Create Hotel Room Offer
   */
  async create(a = {}, n) {
    return this.createRaw(a, n);
  }
}
const jo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class ro extends J {
  /**
   * Delete a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Delete Hotel Room List Guest
   */
  async deleteRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling deleteV1HotelRoomingListGuestsTokenId.");
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling deleteV1HotelRoomingListGuestsTokenId.");
    const i = {}, r = {}, l = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}/{id}".replace("{id}", encodeURIComponent(String(a.id))).replace("{token}", encodeURIComponent(String(a.token))),
      method: "DELETE",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return new Gt(l);
  }
  /**
   * Delete a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Delete Hotel Room List Guest
   */
  async delete(a, n) {
    return this.deleteRaw(a, n);
  }
  /**
   * Update a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Update Hotel Room List Guest
   */
  async updateRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling patchV1HotelRoomingListGuestsTokenId.");
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling patchV1HotelRoomingListGuestsTokenId.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const l = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}/{id}".replace("{id}", encodeURIComponent(String(a.id))).replace("{token}", encodeURIComponent(String(a.token))),
      method: "PATCH",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.hotelRoomingListGuestsUpdateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Update a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Update Hotel Room List Guest
   */
  async update(a, n) {
    return this.updateRaw(a, n);
  }
  /**
   * Create a new hotel rooming list guest to a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Create Hotel Rooming List Guest
   */
  async createRaw(a, n) {
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling postV1HotelRoomingListGuestsToken.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const l = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}".replace("{token}", encodeURIComponent(String(a.token))),
      method: "POST",
      headers: r,
      query: b(i, C.Snake),
      body: b(a.hotelRoomingListGuestsCreateApi, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Create a new hotel rooming list guest to a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Create Hotel Rooming List Guest
   */
  async create(a, n) {
    return this.createRaw(a, n);
  }
}
class oo extends J {
  /**
   * Get Hotel Rooming Lists of a booking. This endpoint is public and does not require a secret API key.
   * Get Hotel Rooming Lists for a booking
   */
  async listRaw(a, n) {
    if (a.token === null || a.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling getV1HotelRoomingListsToken.");
    const i = {};
    a.lang !== void 0 && (i.lang = a.lang);
    const r = {}, l = await this.request({
      path: "/v1/hotel_rooming_lists/{token}".replace("{token}", encodeURIComponent(String(a.token))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Get Hotel Rooming Lists of a booking. This endpoint is public and does not require a secret API key.
   * Get Hotel Rooming Lists for a booking
   */
  async list(a, n) {
    return this.listRaw(a, n);
  }
}
const Jo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class so extends J {
  /**
   * Returns a single Hotel by id with their content localize into the requested **lang**.
   * Retrieve a Hotel
   */
  async retrieveRaw(a, n) {
    if (a.id === null || a.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelsId.");
    const i = {};
    a.event !== void 0 && (i.event = a.event), a.lang !== void 0 && (i.lang = a.lang);
    const r = {};
    this.configuration && this.configuration.apiKey && (r["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const l = await this.request({
      path: "/v1/hotels/{id}".replace("{id}", encodeURIComponent(String(a.id))),
      method: "GET",
      headers: r,
      query: b(i, C.Snake)
    }, n);
    return await new _(l, (s) => b(s, C.Camel)).value();
  }
  /**
   * Returns a single Hotel by id with their content localize into the requested **lang**.
   * Retrieve a Hotel
   */
  async retrieve(a, n) {
    return this.retrieveRaw(a, n);
  }
}
const qo = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
var De = { exports: {} }, za;
function lo() {
  return za || (za = 1, function(e, a) {
    var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof be < "u" && be, i = function() {
      function l() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return l.prototype = n, new l();
    }();
    (function(l) {
      (function(s) {
        var u = typeof l < "u" && l || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof be < "u" && be || {}, d = {
          searchParams: "URLSearchParams" in u,
          iterable: "Symbol" in u && "iterator" in Symbol,
          blob: "FileReader" in u && "Blob" in u && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in u,
          arrayBuffer: "ArrayBuffer" in u
        };
        function f(o) {
          return o && DataView.prototype.isPrototypeOf(o);
        }
        if (d.arrayBuffer)
          var D = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], R = ArrayBuffer.isView || function(o) {
            return o && D.indexOf(Object.prototype.toString.call(o)) > -1;
          };
        function S(o) {
          if (typeof o != "string" && (o = String(o)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(o) || o === "")
            throw new TypeError('Invalid character in header field name: "' + o + '"');
          return o.toLowerCase();
        }
        function w(o) {
          return typeof o != "string" && (o = String(o)), o;
        }
        function v(o) {
          var c = {
            next: function() {
              var m = o.shift();
              return { done: m === void 0, value: m };
            }
          };
          return d.iterable && (c[Symbol.iterator] = function() {
            return c;
          }), c;
        }
        function h(o) {
          this.map = {}, o instanceof h ? o.forEach(function(c, m) {
            this.append(m, c);
          }, this) : Array.isArray(o) ? o.forEach(function(c) {
            if (c.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + c.length);
            this.append(c[0], c[1]);
          }, this) : o && Object.getOwnPropertyNames(o).forEach(function(c) {
            this.append(c, o[c]);
          }, this);
        }
        h.prototype.append = function(o, c) {
          o = S(o), c = w(c);
          var m = this.map[o];
          this.map[o] = m ? m + ", " + c : c;
        }, h.prototype.delete = function(o) {
          delete this.map[S(o)];
        }, h.prototype.get = function(o) {
          return o = S(o), this.has(o) ? this.map[o] : null;
        }, h.prototype.has = function(o) {
          return this.map.hasOwnProperty(S(o));
        }, h.prototype.set = function(o, c) {
          this.map[S(o)] = w(c);
        }, h.prototype.forEach = function(o, c) {
          for (var m in this.map)
            this.map.hasOwnProperty(m) && o.call(c, this.map[m], m, this);
        }, h.prototype.keys = function() {
          var o = [];
          return this.forEach(function(c, m) {
            o.push(m);
          }), v(o);
        }, h.prototype.values = function() {
          var o = [];
          return this.forEach(function(c) {
            o.push(c);
          }), v(o);
        }, h.prototype.entries = function() {
          var o = [];
          return this.forEach(function(c, m) {
            o.push([m, c]);
          }), v(o);
        }, d.iterable && (h.prototype[Symbol.iterator] = h.prototype.entries);
        function M(o) {
          if (!o._noBody) {
            if (o.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            o.bodyUsed = !0;
          }
        }
        function L(o) {
          return new Promise(function(c, m) {
            o.onload = function() {
              c(o.result);
            }, o.onerror = function() {
              m(o.error);
            };
          });
        }
        function O(o) {
          var c = new FileReader(), m = L(c);
          return c.readAsArrayBuffer(o), m;
        }
        function B(o) {
          var c = new FileReader(), m = L(c), g = /charset=([A-Za-z0-9_-]+)/.exec(o.type), y = g ? g[1] : "utf-8";
          return c.readAsText(o, y), m;
        }
        function F(o) {
          for (var c = new Uint8Array(o), m = new Array(c.length), g = 0; g < c.length; g++)
            m[g] = String.fromCharCode(c[g]);
          return m.join("");
        }
        function N(o) {
          if (o.slice)
            return o.slice(0);
          var c = new Uint8Array(o.byteLength);
          return c.set(new Uint8Array(o)), c.buffer;
        }
        function G() {
          return this.bodyUsed = !1, this._initBody = function(o) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = o, o ? typeof o == "string" ? this._bodyText = o : d.blob && Blob.prototype.isPrototypeOf(o) ? this._bodyBlob = o : d.formData && FormData.prototype.isPrototypeOf(o) ? this._bodyFormData = o : d.searchParams && URLSearchParams.prototype.isPrototypeOf(o) ? this._bodyText = o.toString() : d.arrayBuffer && d.blob && f(o) ? (this._bodyArrayBuffer = N(o.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : d.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(o) || R(o)) ? this._bodyArrayBuffer = N(o) : this._bodyText = o = Object.prototype.toString.call(o) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof o == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : d.searchParams && URLSearchParams.prototype.isPrototypeOf(o) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, d.blob && (this.blob = function() {
            var o = M(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var o = M(this);
              return o || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (d.blob)
                return this.blob().then(O);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var o = M(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return B(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(F(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, d.formData && (this.formData = function() {
            return this.text().then(z);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var x = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function Y(o) {
          var c = o.toUpperCase();
          return x.indexOf(c) > -1 ? c : o;
        }
        function k(o, c) {
          if (!(this instanceof k))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          c = c || {};
          var m = c.body;
          if (o instanceof k) {
            if (o.bodyUsed)
              throw new TypeError("Already read");
            this.url = o.url, this.credentials = o.credentials, c.headers || (this.headers = new h(o.headers)), this.method = o.method, this.mode = o.mode, this.signal = o.signal, !m && o._bodyInit != null && (m = o._bodyInit, o.bodyUsed = !0);
          } else
            this.url = String(o);
          if (this.credentials = c.credentials || this.credentials || "same-origin", (c.headers || !this.headers) && (this.headers = new h(c.headers)), this.method = Y(c.method || this.method || "GET"), this.mode = c.mode || this.mode || null, this.signal = c.signal || this.signal || function() {
            if ("AbortController" in u) {
              var p = new AbortController();
              return p.signal;
            }
          }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && m)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(m), (this.method === "GET" || this.method === "HEAD") && (c.cache === "no-store" || c.cache === "no-cache")) {
            var g = /([?&])_=[^&]*/;
            if (g.test(this.url))
              this.url = this.url.replace(g, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var y = /\?/;
              this.url += (y.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        k.prototype.clone = function() {
          return new k(this, { body: this._bodyInit });
        };
        function z(o) {
          var c = new FormData();
          return o.trim().split("&").forEach(function(m) {
            if (m) {
              var g = m.split("="), y = g.shift().replace(/\+/g, " "), p = g.join("=").replace(/\+/g, " ");
              c.append(decodeURIComponent(y), decodeURIComponent(p));
            }
          }), c;
        }
        function P(o) {
          var c = new h(), m = o.replace(/\r?\n[\t ]+/g, " ");
          return m.split("\r").map(function(g) {
            return g.indexOf(`
`) === 0 ? g.substr(1, g.length) : g;
          }).forEach(function(g) {
            var y = g.split(":"), p = y.shift().trim();
            if (p) {
              var E = y.join(":").trim();
              try {
                c.append(p, E);
              } catch (I) {
                console.warn("Response " + I.message);
              }
            }
          }), c;
        }
        G.call(k.prototype);
        function Z(o, c) {
          if (!(this instanceof Z))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (c || (c = {}), this.type = "default", this.status = c.status === void 0 ? 200 : c.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = c.statusText === void 0 ? "" : "" + c.statusText, this.headers = new h(c.headers), this.url = c.url || "", this._initBody(o);
        }
        G.call(Z.prototype), Z.prototype.clone = function() {
          return new Z(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new h(this.headers),
            url: this.url
          });
        }, Z.error = function() {
          var o = new Z(null, { status: 200, statusText: "" });
          return o.ok = !1, o.status = 0, o.type = "error", o;
        };
        var fe = [301, 302, 303, 307, 308];
        Z.redirect = function(o, c) {
          if (fe.indexOf(c) === -1)
            throw new RangeError("Invalid status code");
          return new Z(null, { status: c, headers: { location: o } });
        }, s.DOMException = u.DOMException;
        try {
          new s.DOMException();
        } catch {
          s.DOMException = function(c, m) {
            this.message = c, this.name = m;
            var g = Error(c);
            this.stack = g.stack;
          }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
        }
        function A(o, c) {
          return new Promise(function(m, g) {
            var y = new k(o, c);
            if (y.signal && y.signal.aborted)
              return g(new s.DOMException("Aborted", "AbortError"));
            var p = new XMLHttpRequest();
            function E() {
              p.abort();
            }
            p.onload = function() {
              var T = {
                statusText: p.statusText,
                headers: P(p.getAllResponseHeaders() || "")
              };
              y.url.indexOf("file://") === 0 && (p.status < 200 || p.status > 599) ? T.status = 200 : T.status = p.status, T.url = "responseURL" in p ? p.responseURL : T.headers.get("X-Request-URL");
              var $ = "response" in p ? p.response : p.responseText;
              setTimeout(function() {
                m(new Z($, T));
              }, 0);
            }, p.onerror = function() {
              setTimeout(function() {
                g(new TypeError("Network request failed"));
              }, 0);
            }, p.ontimeout = function() {
              setTimeout(function() {
                g(new TypeError("Network request timed out"));
              }, 0);
            }, p.onabort = function() {
              setTimeout(function() {
                g(new s.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function I(T) {
              try {
                return T === "" && u.location.href ? u.location.href : T;
              } catch {
                return T;
              }
            }
            if (p.open(y.method, I(y.url), !0), y.credentials === "include" ? p.withCredentials = !0 : y.credentials === "omit" && (p.withCredentials = !1), "responseType" in p && (d.blob ? p.responseType = "blob" : d.arrayBuffer && (p.responseType = "arraybuffer")), c && typeof c.headers == "object" && !(c.headers instanceof h || u.Headers && c.headers instanceof u.Headers)) {
              var H = [];
              Object.getOwnPropertyNames(c.headers).forEach(function(T) {
                H.push(S(T)), p.setRequestHeader(T, w(c.headers[T]));
              }), y.headers.forEach(function(T, $) {
                H.indexOf($) === -1 && p.setRequestHeader($, T);
              });
            } else
              y.headers.forEach(function(T, $) {
                p.setRequestHeader($, T);
              });
            y.signal && (y.signal.addEventListener("abort", E), p.onreadystatechange = function() {
              p.readyState === 4 && y.signal.removeEventListener("abort", E);
            }), p.send(typeof y._bodyInit > "u" ? null : y._bodyInit);
          });
        }
        return A.polyfill = !0, u.fetch || (u.fetch = A, u.Headers = h, u.Request = k, u.Response = Z), s.Headers = h, s.Request = k, s.Response = Z, s.fetch = A, s;
      })({});
    })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
    var r = n.fetch ? n : i;
    a = r.fetch, a.default = r.fetch, a.fetch = r.fetch, a.Headers = r.Headers, a.Request = r.Request, a.Response = r.Response, e.exports = a;
  }(De, De.exports)), De.exports;
}
var co = lo();
const uo = /* @__PURE__ */ j(co), go = (e) => ({
  bookingPolicies: new Xr(e),
  bookings: new Qr(e),
  hotelImages: new eo(e),
  hotelOfferRequests: new ao(e),
  hotelOffers: new no(e),
  hotelRoomOfferRequests: new io(e),
  hotelRoomOffers: new to(e),
  hotelRoomingListGuests: new ro(e),
  hotelRoomingLists: new oo(e),
  hotels: new so(e)
});
function mo(e) {
  switch (e) {
    case ne.Production:
      return "AUTH_TOKEN";
    case ne.Sandbox:
      return "AUTH_TOKEN_SANDBOX";
    case ne.Staging:
      return "AUTH_TOKEN_STAGING";
    case ne.CiCd:
      return "AUTH_TOKEN_CICD";
    case ne.Local:
      return "AUTH_TOKEN_LOCAL";
    case void 0:
    default:
      return "AUTH_TOKEN";
  }
}
function rn(e) {
  return !!(typeof document < "u" && document?.cookie && document.cookie.split(";").find(
    (i) => i.includes(mo(e))
  ));
}
class ho {
  constructor(a) {
    this.config = a;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  async pre(a) {
    return a.init.mode = "cors", rn(this.config.apiEnvironment) && (a.init.credentials = "include"), a;
  }
}
class po {
  constructor(a) {
    this.config = a;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  async pre(a) {
    return rn(this.config.apiEnvironment) && (a.init.headers = {
      ...a.init.headers,
      "x-auth-type": "user"
    }), a;
  }
}
class Xo {
  constructor(a) {
    if (this.config = a, !a.apiVersion || !Object.values(We).includes(a.apiVersion))
      throw new Error(
        `Invalid Revolugo Api Version. Possible versions are : ${JSON.stringify(
          Object.values(We)
        )}`
      );
    let n = {
      "x-api-key": this.config.apiKey
    };
    this.config.optionalHeaders && (n = {
      ...n,
      ...this.config.optionalHeaders
    });
    const i = this.config.apiEnvironment;
    let r = this.config.apiBaseUrl ?? ir[i];
    i === ne.Local && process.env.BOOKING_API_BASE_URL && (r = process.env.BOOKING_API_BASE_URL);
    const l = new Ja({
      basePath: r,
      fetchApi: uo,
      headers: n,
      middleware: [
        new ho(this.config),
        new po(this.config)
      ]
    });
    this.apiVersionsToClient = {
      v1: go(l)
    };
  }
  apiVersionsToClient;
  get bookings() {
    return this.apiVersionsToClient[this.config.apiVersion].bookings;
  }
  get bookingPolicies() {
    return this.apiVersionsToClient[this.config.apiVersion].bookingPolicies;
  }
  get hotelOfferRequests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelOfferRequests;
  }
  get hotelOffers() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelOffers;
  }
  get hotelRoomOfferRequests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomOfferRequests;
  }
  get hotelRoomOffers() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomOffers;
  }
  get hotelRoomingListGuests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomingListGuests;
  }
  get hotelRoomingLists() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomingLists;
  }
  get hotels() {
    return this.apiVersionsToClient[this.config.apiVersion].hotels;
  }
  get hotelImages() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelImages;
  }
}
export {
  Xo as ApiClient,
  zt as BASE_PATH,
  J as BaseAPI,
  So as BlobApiResponse,
  Ao as BookingApiPayLaterEnum,
  wo as BookingApiStatusEnum,
  Xr as BookingPolicies,
  vo as BookingPoliciesCreateApiLangEnum,
  Qr as Bookings,
  $o as BookingsSortByEnum,
  xo as BookingsSortByOrderEnum,
  fo as COLLECTION_FORMATS,
  Ja as Configuration,
  Ro as ContactPersonApiLangEnum,
  Mo as ContactPersonApiSalutationEnum,
  Po as CountryIso2Code,
  To as CurrencyBookingApiClient,
  No as ErrorApiResponseTypeEnum,
  eo as HotelImages,
  Yo as HotelImagesLangEnum,
  ao as HotelOfferRequests,
  no as HotelOffers,
  Vo as HotelOffersLangEnum,
  Zo as HotelOffersSortByEnum,
  Wo as HotelOffersSortByOrderEnum,
  Eo as HotelRoomOfferApiBreakfastOptionEnum,
  Bo as HotelRoomOfferApiPackageTypeEnum,
  zo as HotelRoomOfferApiTypeEnum,
  io as HotelRoomOfferRequests,
  to as HotelRoomOffers,
  Lo as HotelRoomOffersCreateApiLangEnum,
  jo as HotelRoomOffersLangEnum,
  ro as HotelRoomingListGuests,
  oo as HotelRoomingLists,
  Jo as HotelRoomingListsLangEnum,
  so as Hotels,
  qo as HotelsLangEnum,
  Oo as InvoiceApiTypeEnum,
  _ as JSONApiResponse,
  Io as PaymentMethodApiOneOf1NameEnum,
  Ko as PaymentMethodApiOneOf2NameEnum,
  Go as PaymentMethodApiOneOfNameEnum,
  _o as PaymentMethodRequestApiNameEnum,
  Uo as PollerStatus,
  U as RequiredError,
  Ot as ResponseError,
  Fo as SourceMarket,
  ko as TaxApiTaxFrequencyEnum,
  Ho as TaxApiTaxModeEnum,
  Gt as TextApiResponse,
  Co as VoidApiResponse,
  Do as canConsumeForm,
  yo as exists,
  bo as mapValues,
  qa as querystring,
  go as v1ApiClient
};
